import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { baseURL } from 'src/actions/types';
import {
  createBusinessModule,
  getBusinessModule,
  clearBusinessModuleError,
  clearBusinessModuleSuccess
} from '../../actions/businessModuleActions';
import { updateUser } from 'src/actions/loginAction';
import {
  getAllBusinessModels,
} from '../../actions/adminBusinessModelActions';
import { getAllAddonPackages } from 'src/actions/addonPackageActions';
import { createRazorpayOrder } from 'src/actions/paymentActions';
import { getAllDiscounts } from '../../actions/discountActions';
import { Link } from 'react-router-dom'; 
// New actions for addon management
// Ye import add karo existing imports ke saath
import { sendConfirmationSms } from 'src/actions/smsActions';
import { updateSubscriptionStatus } from 'src/actions/loginAction';
import {
  createBusinessAddon,
  getBusinessAddons,
  updateBusinessAddon
} from '../../actions/businessAddonActions';

// MessageModal Component
import MessageModal from '../Pages/MessageModel';

// Payment Status Component (Embedded)
const PaymentStatus = ({ status, message, onClose }) => {
  if (!status) return null;

  return (
    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Payment Status</h5>
            <button type="button" className="close" onClick={onClose}>
              <span>×</span>
            </button>
          </div>
          <div className="modal-body text-center">
            {status === 'processing' && (
              <>
                <div className="spinner-border text-info mb-3" style={{ width: '3rem', height: '3rem' }} role="status">
                  <span className="sr-only">Loading...</span>
                </div>
                <h5>Processing Payment...</h5>
                <p className="text-muted">{message}</p>
              </>
            )}
            
            {status === 'success' && (
              <>
                <div className="text-success mb-3">
                  <i className="fas fa-check-circle" style={{ fontSize: '3rem' }}></i>
                </div>
                <h5 className="text-success">Payment Successful!</h5>
                <p>{message}</p>
              </>
            )}
            
            {status === 'failed' && (
              <>
                <div className="text-danger mb-3">
                  <i className="fas fa-times-circle" style={{ fontSize: '3rem' }}></i>
                </div>
                <h5 className="text-danger">Payment Failed</h5>
                <p>{message}</p>
              </>
            )}
            
            {status === 'error' && (
              <>
                <div className="text-warning mb-3">
                  <i className="fas fa-exclamation-triangle" style={{ fontSize: '3rem' }}></i>
                </div>
                <h5 className="text-warning">Payment Error</h5>
                <p>{message}</p>
              </>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-info rounded-pill"
              onClick={onClose}
            >
              {status === 'processing' ? 'Cancel' : 'Close'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// Payment Gateway Modal Component
const PaymentGatewayModal = ({
  show,
  onClose,
  gateways,
  selectedGateway,
  onSelectGateway,
  onConfirm,
  amount,
  loading = false,
  planType = 'subscription'
}) => {
  if (!show) return null;

  return (
    <div
      className="modal fade show"
      style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              {planType === 'commission' ? 'Complete Module Payment' : 'Complete Plan Payment'}
            </h5>
            <button type="button" className="close" onClick={onClose} disabled={loading}>
              <span>×</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="text-center mb-3">
              <h6 className="text-info">Total Amount: ₹{amount}</h6>
              {planType === 'commission' && (
                <small className="text-muted">For selected paid modules</small>
              )}
              {planType === 'subscription' && (
                <small className="text-muted">
                  {amount > 0 ? 'For plan and selected modules' : 'For selected modules only'}
                </small>
              )}
            </div>
            <div className="form-group">
              <label>Choose your payment method:</label>
              <div className="gateway-options">
                {gateways.map((gateway) => (
                  <div key={gateway} className="form-check mb-2">
                    <input
                      type="radio"
                      className="form-check-input"
                      id={`gateway-${gateway}`}
                      name="selectedGateway"
                      value={gateway}
                      checked={selectedGateway === gateway}
                      onChange={() => onSelectGateway(gateway)}
                      disabled={loading}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`gateway-${gateway}`}
                    >
                      {gateway.charAt(0).toUpperCase() + gateway.slice(1)}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-info"
              onClick={onConfirm}
              disabled={!selectedGateway || loading}
            >
              {loading ? "Processing..." : `Pay ₹${amount}`}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const PlanSelection = ({ doctorId, hospitalId, onPlanSelected }) => {
  const dispatch = useDispatch();
// const prepareCleanUserPayload = (newStatus, newType) => {
//   const savedData = localStorage.getItem('loginData');
//   const loginData = savedData ? JSON.parse(savedData) : {};
  
//   // hospitalID hamesha integer hona chahiye
//   const hID = parseInt(localStorage.getItem('hospitalCode')) || loginData.hospitalID;

//   return {
//     hospitalID: hID,
//     username: loginData.username,
//     // Password update API mein zaroori hota hai, loginData se lein
//     password: loginData.password || "123", 
//     first_name: loginData.first_name,
//     last_name: loginData.last_name,
//     email: loginData.email,
//     role: loginData.role || "Admin",
//     mobile: loginData.mobile,
//     app_status: "enabled",
//     subscription_status: newStatus, // "active"
//     Subscription_type: newType      // "subscription" ya "commission"
//     // 'created_at' ko nikaal dein kyunki use update nahi kiya jata, 
//     // is wajah se bhi 500 error aa sakti hai.
//   };
// };

  // Redux state selectors
// Replace your current prepareCleanUserPayload function with this:

// const prepareCleanUserPayload = (newStatus, newType) => {
//   const savedData = localStorage.getItem('loginData');
//   const loginData = savedData ? JSON.parse(savedData) : {};

//   return {
//     hospitalID: parseInt(loginData.hospitalID) || parseInt(hospitalID),
//     username: loginData.username,
//     password: loginData.password || "123",
//     first_name: loginData.first_name,
//     last_name: loginData.last_name,
//     email: loginData.email,
//     role: loginData.role || "Admin",
//     mobile: loginData.mobile,
//     app_status: "enabled",
//     created_at: loginData.created_at,
//     subscription_status: newStatus, // Ensure this is 'active'
//     Subscription_type: newType      // Ensure this is 'subscription' or 'commission'
//   };
// };
const prepareCleanUserPayload = (newStatus, newType) => {
  const savedData = localStorage.getItem('loginData');
  const loginData = savedData ? JSON.parse(savedData) : {};
  
  // Destructure karke token ko nikal dein (aapne kaha tha token nahi bhejna)
  const { token, ...dataWithoutToken } = loginData;

  return {
    ...dataWithoutToken, // Pura data lein
    hospitalID: parseInt(dataWithoutToken.hospitalID || hospitalID),
    subscription_status: newStatus,
    Subscription_type: newType,
    app_status: "enabled",
    password: dataWithoutToken.password // Password API require kar sakti hai
  };
};
  const { loading, error, success, businessModules } = useSelector(state => state.businessModule);
  const { businessModels, loading: loadingBusinessModels } = useSelector(state => state.businessModels || {});
  const { addonPackages, loading: loadingAddonPackages } = useSelector(state => state.addonPackages || {});
  const { discounts, loading: loadingDiscounts } = useSelector(state => state.discounts || {});
  const { businessAddons, loading: loadingAddons } = useSelector(state => state.businessAddons || {});

  // Component state
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [selectedPlanId, setSelectedPlanId] = useState(null);
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [basePlanValidity, setBasePlanValidity] = useState(1);
  const [addonValidity, setAddonValidity] = useState(1);
  const [localError, setLocalError] = useState('');
  const [currentPlan, setCurrentPlan] = useState(null);
  const [planHistory, setPlanHistory] = useState([]);
  const [isModifyingExisting, setIsModifyingExisting] = useState(false);
  const [showConfirmUpgrade, setShowConfirmUpgrade] = useState(false);
  const [isActivating, setIsActivating] = useState(false);
  const [isLoadingDynamicData, setIsLoadingDynamicData] = useState(true);
  const [confirmMessage, setConfirmMessage] = useState('');
  const [realTimeUpdates, setRealTimeUpdates] = useState(0);

  // Payment states
  const [gateways, setGateways] = useState([]);
  const [selectedGateway, setSelectedGateway] = useState("");
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);
  const [pendingPaymentData, setPendingPaymentData] = useState(null);

  // Cashfree payment states
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [paymentStatusMessage, setPaymentStatusMessage] = useState('');
  const [isCheckingPayment, setIsCheckingPayment] = useState(false);
  const [cashfreeOrderId, setCashfreeOrderId] = useState(null);
  const [cashfreeAppointmentId, setCashfreeAppointmentId] = useState(null);

  // Modification states
  const [modificationMode, setModificationMode] = useState(false);

  // Message Modal states
  const [modalShow, setModalShow] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalMessage, setModalMessage] = useState("");
  const [modalVariant, setModalVariant] = useState("success");

  const hospitalID = localStorage.getItem('hospitalCode');
  const lastSelectedPlanRef = useRef(null);
  const [localSuccess, setLocalSuccess] = useState(false);

  // ==================== LOGGING UTILITIES ====================

  const log = (message, data = null, type = 'info') => {
    const timestamp = new Date().toISOString();
    const styles = {
      info: 'color: blue; font-weight: bold;',
      success: 'color: green; font-weight: bold;',
      warning: 'color: orange; font-weight: bold;',
      error: 'color: red; font-weight: bold;',
      debug: 'color: purple; font-weight: bold;'
    };

    console.log(`%c[${timestamp}] ${message}`, styles[type], data !== null ? data : '');
  };

  // ==================== MESSAGE MODAL FUNCTIONS ====================

  const showMessage = (title, message, variant = "success") => {
    setModalTitle(title);
    setModalMessage(message);
    setModalVariant(variant);
    setModalShow(true);
  };

  const showSuccess = (message) => {
    showMessage("Success", message, "success");
  };

  const showError = (message) => {
    showMessage("Error", message, "danger");
  };

  const showWarning = (message) => {
    showMessage("Warning", message, "warning");
  };

  const showInfo = (message) => {
    showMessage("Info", message, "info");
  };

  // ==================== CASHFREE PAYMENT HANDLING ====================

  // Initialize Cashfree SDK
  const initializeCashfree = () => {
    return new Promise((resolve, reject) => {
      if (typeof window.Cashfree !== 'undefined') {
        resolve(new window.Cashfree({
          mode: process.env.REACT_APP_CASHFREE_MODE || "sandbox"
        }));
        return;
      }

      const script = document.createElement("script");
      script.src = "https://sdk.cashfree.com/js/v3/cashfree.js";
      script.onload = () => {
        resolve(new window.Cashfree({
          mode: process.env.REACT_APP_CASHFREE_MODE || "sandbox"
        }));
      };
      script.onerror = () => reject(new Error("Failed to load Cashfree SDK"));
      document.body.appendChild(script);
    });
  };

  const handleCashfreePayment = async (paymentSessionId, orderId, paymentData) => {
    try {
      setPaymentStatus('processing');
      setPaymentStatusMessage('Initializing Cashfree payment...');

      const cashfree = await initializeCashfree();

      // Store payment data in localStorage BEFORE redirecting
      localStorage.setItem('cashfreePendingPayment', JSON.stringify({
        orderId: orderId,
        ourInternalPaymentData: paymentData,
        timestamp: Date.now(),
        statusChecked: false
      }));

      cashfree.checkout({
        paymentSessionId: paymentSessionId,
        redirectTarget: "_self",
      });
    } catch (error) {
      console.error('Cashfree initialization error:', error);
      setPaymentStatus('error');
      setPaymentStatusMessage('Failed to initialize payment. Please try again.');
      setIsProcessingPayment(false);
    }
  };

  const checkPaymentStatus = async (orderId) => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${baseURL}/api/appointmentPaymentTransactions/getAll`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ gateway_order_id: orderId }),
      });
  
      const data = await response.json();
  
      if (data.success && Array.isArray(data.data)) {
        const transaction = data.data.find(
          tx => tx.gateway_order_id === orderId.toString()
        );
  
        if (transaction) {
          // Also check businessmodule and businessaddon tables
          const moduleResponse = await fetch(`${baseURL}/api/businessmodule/getAll`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ gateway_order_id: orderId })
          });
          
          const moduleData = await moduleResponse.json();
          
          const addonResponse = await fetch(`${baseURL}/api/businessaddon/getAll`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ gateway_order_id: orderId })
          });
          
          const addonData = await addonResponse.json();
          
          // If any record shows success, consider it successful
          if ((moduleData.success && moduleData.data.some(item => item.payment_status === 'Paid')) ||
              (addonData.success && addonData.data.some(item => item.payment_status === 'Paid')) ||
              transaction.status === 'success') {
            return {
              success: true,
              transactionData: transaction
            };
          }
        }
      }
  
      return { success: false, transactionData: null };
    } catch (error) {
      console.error('Error checking payment status:', error);
      return { success: false, transactionData: null, error: error.message };
    }
  };

  // ==================== DYNAMIC VALIDITY FUNCTIONS ====================

  // Get dynamic validity options from discounts
  const getValidityOptions = () => {
    log('🔄 Getting validity options from discounts', discounts);

    if (!discounts || discounts.length === 0) {
      log('📝 No discounts found, using default validity options');
      return [
        { value: 1, label: '1 Month', discount: 0, originalLabel: '1 Month' },
        { value: 2, label: '2 Months', discount: 0, originalLabel: '2 Months' },
        { value: 3, label: '3 Months', discount: 0, originalLabel: '3 Months' },
        { value: 6, label: '6 Months', discount: 0, originalLabel: '6 Months' },
        { value: 12, label: '1 Year', discount: 0, originalLabel: '1 Year' },
        { value: 24, label: '2 Years', discount: 0, originalLabel: '2 Years' }
      ];
    }

    const options = discounts
      .filter(discount => discount.status === 'active')
      .map(discount => {
        const month = parseInt(discount.month) || 1;
        const discountValue = parseFloat(discount.discount) || 0;

        let label = '';
        if (month === 1) label = '1 Month';
        else if (month === 12) label = '1 Year';
        else if (month === 24) label = '2 Years';
        else label = `${month} Months`;

        return {
          value: month,
          label: discountValue > 0 ? `${label} (${discountValue}% off)` : label,
          discount: discountValue,
          originalLabel: label
        };
      })
      .sort((a, b) => a.value - b.value);

    log('✅ Validity options generated', options);
    return options;
  };

  // Get current validity option for base plan
  const getCurrentBaseValidityOption = () => {
    const validityOptions = getValidityOptions();
    const option = validityOptions.find(opt => opt.value === basePlanValidity) || validityOptions[0];
    log('📊 Current base validity option', { basePlanValidity, option });
    return option;
  };

  // Get current validity option for addons
  const getCurrentAddonValidityOption = () => {
    const validityOptions = getValidityOptions();
    const option = validityOptions.find(opt => opt.value === addonValidity) || validityOptions[0];
    log('📊 Current addon validity option', { addonValidity, option });
    return option;
  };

  // For subscription plans, ensure addon validity <= base plan validity
  // const getFilteredAddonValidityOptions = () => {
  //   const allOptions = getValidityOptions();

  //   if (selectedPlan === 'subscription') {
  //     if (isModifyingCurrentPlan() && currentPlan) {
  //       // For modification mode, get remaining months from current plan
  //       const validToDate = parseDate(currentPlan.valid_To);
  //       if (validToDate) {
  //         const today = new Date();
  //         const diffTime = validToDate - today;
  //         const remainingMonths = Math.ceil(diffTime / (1000 * 60 * 60 * 24 * 30));
  //         const maxValidity = Math.max(1, remainingMonths);

  //         const filtered = allOptions.filter(option => option.value <= maxValidity);
  //         log('🎯 Filtered addon validity options for subscription modification', {
  //           remainingMonths,
  //           maxValidity,
  //           allOptions: allOptions.length,
  //           filtered: filtered.length
  //         });
  //         return filtered;
  //       }
  //     } else if (!isModifyingCurrentPlan()) {
  //       // For new plans, use base plan validity
  //       const filtered = allOptions.filter(option => option.value <= basePlanValidity);
  //       log('🎯 Filtered addon validity options for new subscription', {
  //         basePlanValidity,
  //         allOptions: allOptions.length,
  //         filtered: filtered.length
  //       });
  //       return filtered;
  //     }
  //   }

  //   log('🎯 Using all addon validity options', { allOptions: allOptions.length });
  //   return allOptions;
  // };
const getFilteredAddonValidityOptions = () => {
    const allOptions = getValidityOptions();

    // Agar hum naya subscription le rahe hain
    if (selectedPlan === 'subscription' && !modificationMode) {
        // Base validity se chote ya barabar wale options dikhayein
        return allOptions.filter(option => option.value <= basePlanValidity);
    }
    
    // Modification mode me purana logic chalne dein
    return allOptions; 
};
  // Handle base plan validity change
  const handleBasePlanValidityChange = (value) => {
    const newBaseValidity = parseInt(value);
    log('🔄 Base plan validity change', { from: basePlanValidity, to: newBaseValidity });

    setBasePlanValidity(newBaseValidity);

    // For subscription plans, adjust addon validity if needed
    if (selectedPlan === 'subscription' && !isModifyingCurrentPlan()) {
      if (addonValidity > newBaseValidity) {
        log('📝 Adjusting addon validity to match base plan', { from: addonValidity, to: newBaseValidity });
        setAddonValidity(newBaseValidity);
      }
    }
  };

  // Handle addon validity change with validation
  const handleAddonValidityChange = (value) => {
    const newAddonValidity = parseInt(value);
    log('🔄 Addon validity change attempt', { from: addonValidity, to: newAddonValidity });

    if (selectedPlan === 'subscription') {
      if (isModifyingCurrentPlan() && currentPlan) {
        // For modification mode, check against remaining plan validity
        const validToDate = parseDate(currentPlan.valid_To);
        if (validToDate) {
          const today = new Date();
          const diffTime = validToDate - today;
          const remainingMonths = Math.ceil(diffTime / (1000 * 60 * 60 * 24 * 30));
          const maxValidity = Math.max(1, remainingMonths);

          if (newAddonValidity > maxValidity) {
            log('❌ Addon validity exceeds remaining plan validity', { newAddonValidity, maxValidity });
            setLocalError(`Addon validity cannot exceed your remaining plan validity of ${maxValidity} month${maxValidity > 1 ? 's' : ''}`);
            return;
          }
        }
      } else if (!isModifyingCurrentPlan()) {
        // For new plans, check against base plan validity
        if (newAddonValidity > basePlanValidity) {
          log('❌ Addon validity exceeds base plan validity', { newAddonValidity, basePlanValidity });
          setLocalError('Addon validity cannot exceed base plan validity for subscription plans');
          return;
        }
      }
    }

    log('✅ Addon validity change approved', { newAddonValidity });
    setLocalError('');
    setAddonValidity(newAddonValidity);
  };

  // ==================== ADDON MANAGEMENT FUNCTIONS ====================

  const getActiveBusinessAddons = () => {
    if (!businessAddons || !Array.isArray(businessAddons)) {
      log('📦 No business addons found or not an array', businessAddons);
      return [];
    }

    const activeAddons = businessAddons.filter(addon => {
      const hospitalMatch = addon.hospitalID === parseInt(hospitalID);
      const statusMatch = addon.status === 'active';
      let dateValid = true;
      if (addon.valid_date) {
        const validDate = parseDate(addon.valid_date);
        dateValid = validDate && validDate > new Date();
      }

      const isActive = hospitalMatch && statusMatch && dateValid;
      return isActive;
    });

    log('📦 Active business addons retrieved', {
      totalAddons: businessAddons.length,
      activeAddons: activeAddons.length
    });

    return activeAddons;
  };

  // Calculate addon validity end date
  const calculateAddonEndDate = (startDate, validityMonths) => {
    const start = new Date(startDate);
    const endDate = new Date(start);
    endDate.setMonth(endDate.getMonth() + validityMonths);
    log('📅 Addon end date calculated', { startDate, validityMonths, endDate });
    return endDate;
  };

  // Format date for database (DD-MM-YYYY)
  const formatDateForDB = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const formatted = `${day}-${month}-${year}`;
    log('📅 Date formatted for DB', { input: date, output: formatted });
    return formatted;
  };

  // Format date for display - handle DD-MM-YYYY format
  const formatDisplayDate = (dateString) => {
    if (!dateString) {
      log('📅 No date string provided for display formatting');
      return 'No expiry';
    }

    try {
      const parts = dateString.split('-');
      if (parts.length === 3) {
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1;
        const year = parseInt(parts[2], 10);

        if (day > 0 && day <= 31 && month >= 0 && month < 12 && year > 0) {
          const date = new Date(year, month, day);
          if (!isNaN(date.getTime())) {
            const formatted = date.toLocaleDateString('en-IN', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric'
            });
            log('📅 Date formatted for display', { input: dateString, output: formatted });
            return formatted;
          }
        }
      }

      log('❌ Invalid date format for display', dateString);
      return 'Invalid Date';
    } catch (error) {
      log('❌ Error formatting display date', { dateString, error }, 'error');
      return 'Invalid Date';
    }
  };

  // FIXED: handleRemoveAddon function
  const handleRemoveAddon = async (addonId) => {
    try {
      log('🗑️ Removing addon attempt', { addonId });

      const addonToRemove = getActiveBusinessAddons().find(addon => {
        const addonPackagesMap = getAddonPackages();
        const addonName = addonPackagesMap[addonId]?.name;
        return addon.addon_name === addonName;
      });

      if (!addonToRemove) {
        log('❌ Addon not found for removal', addonId);
        showError('Addon not found');
        return;
      }

      log('🔍 Addon found for removal', addonToRemove);

      setModalTitle("Confirm Removal");
      setModalMessage(`Are you sure you want to remove "${addonToRemove.addon_name}"? This action cannot be undone and you won't be able to use this feature anymore.`);
      setModalVariant("warning");
      setModalShow(true);

      window.pendingAddonRemoval = {
        addonToRemove,
        addonId
      };

    } catch (error) {
      log('❌ Error in remove addon flow', error, 'error');
      showError('Failed to initiate addon removal. Please try again.');
    }
  };

  // FIXED: confirmAddonRemoval function
  const confirmAddonRemoval = async () => {
    if (!window.pendingAddonRemoval) {
      showError('No addon removal pending');
      return;
    }

    const { addonToRemove, addonId } = window.pendingAddonRemoval;
    
    try {
      setModalMessage(`Removing "${addonToRemove.addon_name}"...`);
      setModalVariant("info");
      
      const updateData = {
        id: addonToRemove.id,
        status: 'removed'
      };

      log('📤 Sending update request to remove addon', updateData);

      await dispatch(updateBusinessAddon(updateData));
      await dispatch(getBusinessAddons({ hospitalID: parseInt(hospitalID) }));

      setSelectedAddons(prev => prev.filter(id => id !== addonId));
      setRealTimeUpdates(prev => prev + 1);

      showSuccess(`${addonToRemove.addon_name} removed successfully!`);
      
    } catch (error) {
      log('❌ Error removing addon', error, 'error');
      showError('Failed to remove addon. Please try again.');
    } finally {
      window.pendingAddonRemoval = null;
      setModalShow(false);
    }
  };

  // Create addon payload for database
  const createAddonPayload = (addonId, addonData, validity, amount, transactionId, basePlanType) => {
    const today = new Date();
    const endDate = calculateAddonEndDate(today, validity);

    const payload = {
      hospitalID: parseInt(hospitalID),
      addon_name: addonData.name,
      start_date: formatDateForDB(today),
      valid_date: formatDateForDB(endDate),
      amount: amount,
      transactionId: transactionId,
      status: 'active',
      payment_status: 'paid' // Added payment_status field
    };

    log('📦 Addon payload created', payload);
    return payload;
  };

  // ==================== CALCULATION FUNCTIONS ====================

  // Calculate pro-rata amount for exact remaining days
  const calculateProRataAmount = (addonPrice, remainingDays = 0) => {
    if (remainingDays <= 0) {
      log('💰 Pro-rata calculation: no remaining days', { addonPrice, remainingDays });
      return 0;
    }

    const daysInMonth = 30;
    const dailyRate = addonPrice / daysInMonth;
    const proRataAmount = dailyRate * remainingDays;
    const result = Math.max(0, proRataAmount);

    log('💰 Pro-rata amount calculated', {
      addonPrice,
      remainingDays,
      dailyRate,
      proRataAmount: result
    });

    return result;
  };

  // Calculate remaining days in current billing cycle
  const calculateRemainingDays = (validTo) => {
    if (!validTo) {
      log('📅 No validTo date provided for remaining days calculation');
      return 0;
    }

    try {
      const validToDate = new Date(validTo);
      const today = new Date();
      const diffTime = Math.abs(validToDate - today);
      const remainingDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      log('📅 Remaining days calculated', { validTo, validToDate, today, remainingDays });
      return remainingDays;
    } catch (error) {
      log('❌ Error calculating remaining days', { validTo, error }, 'error');
      return 0;
    }
  };

  // Parse date from DD-MM-YYYY format
  const parseDate = (dateString) => {
    if (!dateString) {
      log('📅 No date string provided for parsing');
      return null;
    }

    try {
      const parts = dateString.split('-');
      if (parts.length === 3) {
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1;
        const year = parseInt(parts[2], 10);

        if (day > 0 && day <= 31 && month >= 0 && month < 12 && year > 0) {
          const date = new Date(year, month, day);
          if (!isNaN(date.getTime())) {
            log('📅 Date parsed successfully', { input: dateString, output: date });
            return date;
          }
        }
      }

      log('❌ Invalid date format or values', dateString);
      return null;
    } catch (error) {
      log('❌ Error parsing date', { dateString, error }, 'error');
      return null;
    }
  };

  // Calculate discounted price using dynamic discounts
  const calculateDiscountedPrice = (basePrice, validity, discountOptions = getValidityOptions()) => {
    const option = discountOptions.find(opt => opt.value === validity);
    const discount = option ? option.discount : 0;
    const discountedPrice = basePrice * (1 - discount / 100);

    const result = {
      original: basePrice,
      discounted: discountedPrice,
      discount: discount,
      savings: basePrice - discountedPrice,
      label: option?.originalLabel || `${validity} Month${validity > 1 ? 's' : ''}`
    };

    log('💰 Discounted price calculated', { basePrice, validity, discount, result });
    return result;
  };

  // ==================== ADDON PACKAGES MANAGEMENT ====================

  const getAddonPackages = () => {
    const activeAddons = addonPackages?.filter(pkg => pkg.status === 'active') || [];
    const addonsMap = {};

    activeAddons.forEach(addon => {
      const addonId = addon.id?.toString();
      if (addonId) {
        addonsMap[addonId] = {
          id: addonId,
          name: addon.package_name || 'Addon',
          price: parseFloat(addon.price) || 0,
          period: 'month',
          description: addon.description || 'Additional feature',
          feature: addon.package_name || 'Feature',
          packageData: addon
        };
      }
    });

    log('📦 Addon packages processed', {
      totalActive: activeAddons.length,
      mapped: Object.keys(addonsMap).length
    });

    return addonsMap;
  };

  // Check if addon is already active in business_addons table
  const checkIfAddonActive = (addonId) => {
    const activeBusinessAddons = getActiveBusinessAddons();
    const addonPackagesMap = getAddonPackages();
    const addonName = addonPackagesMap[addonId]?.name;

    const isActive = activeBusinessAddons.some(addon => addon.addon_name === addonName);

    log('🔍 Checking if addon is active', {
      addonId,
      addonName,
      isActive
    });

    return isActive;
  };

  // Get existing active addons (from business_addons table)
  const getExistingAddons = () => {
    const activeBusinessAddons = getActiveBusinessAddons();
    const addonPackagesMap = getAddonPackages();

    const existingAddons = activeBusinessAddons.map(addon => {
      const matchingAddon = Object.values(addonPackagesMap).find(
        pkg => pkg.name === addon.addon_name
      );
      return matchingAddon?.id;
    }).filter(Boolean);

    log('📦 Existing addons retrieved', {
      activeBusinessAddons: activeBusinessAddons.length,
      existingAddons
    });

    return existingAddons;
  };

  // Get newly selected addons (not in existing addons)
  const getNewAddons = () => {
    const existingAddons = getExistingAddons();
    const newAddons = selectedAddons.filter(addonId => !existingAddons.includes(addonId));

    log('🆕 New addons identified', {
      existingAddons,
      selectedAddons,
      newAddons
    });

    return newAddons;
  };

  // ==================== PAYMENT CALCULATION FUNCTIONS ====================

  // Calculate addon total with dynamic validity - FIXED FOR MODIFICATION
  const calculateAddonTotal = () => {
    const addons = getAddonPackages();
    const newAddons = getNewAddons();

    log('💰 Addon total calculation started', {
      selectedAddons,
      newAddons,
      isModifyingCurrentPlan: isModifyingCurrentPlan(),
      currentPlan,
      addonValidity
    });

    let baseAddonTotal = 0;
    let proRataDetails = {};
    let isProRata = false;

    baseAddonTotal = newAddons.reduce((total, addonId) => {
      const addonPrice = addons[addonId]?.price || 0;
      const addonAmount = addonPrice * addonValidity;

      proRataDetails[addonId] = {
        fullPrice: addonPrice,
        validityMonths: addonValidity,
        totalAmount: addonAmount,
        addonName: addons[addonId]?.name || addonId
      };

      return total + addonAmount;
    }, 0);

    isProRata = isModifyingCurrentPlan() && newAddons.length > 0;

    const addonDiscount = calculateDiscountedPrice(baseAddonTotal, addonValidity);
    const addonTotal = addonDiscount.discounted;

    const result = {
      baseAddonTotal,
      addonTotal,
      addonDiscount: addonDiscount.discount,
      addonSavings: addonDiscount.savings,
      total: addonTotal,
      newAddons,
      proRataDetails,
      isProRata,
      shouldCharge: newAddons.length > 0
    };

    log('💰 Final addon total calculation result', result);
    return result;
  };

  // ==================== PLAN CALCULATIONS ====================

  const calculateSubscriptionTotal = () => {
    if (selectedPlan !== 'subscription') {
      log('❌ Not a subscription plan, skipping calculation');
      return 0;
    }

    const selectedPlanData = getSelectedPlanDetails();
    if (!selectedPlanData) {
      log('❌ No selected plan data found');
      return 0;
    }

    const isModification = isModifyingCurrentPlan();
    log('💰 Subscription total calculation', { isModification, selectedPlanData });

    if (isModification) {
      const { addonTotal, addonSavings, proRataDetails, isProRata } = calculateAddonTotal();
      const result = {
        total: addonTotal,
        basePrice: 0,
        baseSavings: 0,
        baseDiscount: 0,
        addonTotal,
        addonSavings,
        proRataDetails,
        isProRata,
        isModification: true
      };

      log('💰 Subscription modification calculation result', result);
      return result;
    }

    const basePriceCalculation = calculateDiscountedPrice(selectedPlanData.price, basePlanValidity);
    const basePrice = basePriceCalculation.discounted * basePlanValidity;

    const { addonTotal, addonSavings, proRataDetails, isProRata } = calculateAddonTotal();
    const total = basePrice + addonTotal;

    const result = {
      total,
      basePrice: basePriceCalculation.discounted * basePlanValidity,
      baseSavings: basePriceCalculation.savings * basePlanValidity,
      baseDiscount: basePriceCalculation.discount,
      addonTotal,
      addonSavings,
      proRataDetails,
      isProRata,
      isModification: false
    };

    log('💰 New subscription calculation result', result);
    return result;
  };

  const calculateCommissionTotal = () => {
    if (selectedPlan !== 'commission') {
      log('❌ Not a commission plan, skipping calculation');
      return null;
    }

    const addonCalculation = calculateAddonTotal();
    const isModification = isModifyingCurrentPlan();
    const isPlanSwitch = currentPlan && currentPlan.businessType !== selectedPlan;

    const shouldCharge = addonCalculation.newAddons.length > 0 && addonCalculation.total > 0;

    const result = {
      total: addonCalculation.total || 0,
      addonTotal: addonCalculation.addonTotal || 0,
      addonSavings: addonCalculation.addonSavings || 0,
      addonDiscount: addonCalculation.addonDiscount || 0,
      proRataDetails: addonCalculation.proRataDetails || {},
      isProRata: addonCalculation.isProRata || false,
      newAddons: addonCalculation.newAddons || [],
      shouldCharge: shouldCharge,
      hasAddons: selectedAddons.length > 0,
      newAddonsCount: addonCalculation.newAddons?.length || 0,
      isPlanSwitch: isPlanSwitch
    };

    log('💰 Commission total calculation result', result);
    return result;
  };

  // ==================== EFFECT HOOKS ====================

  // useEffect(() => {
  //   const handleCashfreeRedirect = async () => {
  //     const pendingPayment = localStorage.getItem('cashfreePendingPayment');

  //     if (pendingPayment) {
  //       let paymentInfo;
  //       try {
  //         paymentInfo = JSON.parse(pendingPayment);
  //         if (paymentInfo.statusChecked) {
  //           log('🔍 Cashfree payment already processed or checked. Clearing local storage.', paymentInfo);
  //           localStorage.removeItem('cashfreePendingPayment');
  //           return;
  //         }
  //       } catch (e) {
  //         console.error('Error parsing cashfreePendingPayment from localStorage:', e);
  //         localStorage.removeItem('cashfreePendingPayment');
  //         return;
  //       }

  //       log('🔄 Detected pending Cashfree payment after redirect:', paymentInfo);
  //       setIsProcessingPayment(true);
  //       setPaymentStatus('processing');
  //       setPaymentStatusMessage('Verifying Cashfree payment status...');

  //       try {
  //         const pollingResult = await pollPaymentStatusWithTimeout(paymentInfo.orderId, 60000);

  //         if (pollingResult.success) {
  //           log('✅ Cashfree payment verified successfully.', pollingResult.transactionData);
  //           setPaymentStatus('success');
  //           setPaymentStatusMessage('Payment verified! Activating plan...');

  //           paymentInfo.statusChecked = true;
  //           localStorage.setItem('cashfreePendingPayment', JSON.stringify(paymentInfo));

  //           await createBusinessModuleAfterPayment({
  //             ...paymentInfo.ourInternalPaymentData,
  //             transactionId: pollingResult.transactionData.transaction_uid || paymentInfo.orderId,
  //             status: "Paid"
  //           });

  //         } else if (pollingResult.timeout) {
  //           log('⏰ Payment verification timeout after 1 minute. Creating pending record...');
            
  //           await createPendingBusinessModule(paymentInfo);
            
  //           setPaymentStatus('pending');
  //           setPaymentStatusMessage('Payment is being processed. Your plan will be activated once payment is confirmed.');
  //           showWarning('Payment is still processing. Your plan will be activated automatically once payment is confirmed. Please check your transaction history.');
            
  //         } else {
  //           log('❌ Cashfree payment verification failed.', pollingResult.error);
  //           setPaymentStatus('failed');
  //           setPaymentStatusMessage(`Payment verification failed: ${pollingResult.error || 'Unknown error.'}`);
  //           showError(`Payment failed or could not be verified: ${pollingResult.error || 'Please check your transaction history or contact support.'}`);
  //         }
  //       } catch (verificationError) {
  //         log('❌ Error during Cashfree payment verification:', verificationError, 'error');
  //         setPaymentStatus('error');
  //         setPaymentStatusMessage('An error occurred during payment verification. Please contact support.');
  //         showError('An error occurred during payment verification. Please contact support.');
  //       } finally {
  //         setIsProcessingPayment(false);
  //         setShowPaymentModal(false);
  //       }
  //     }
  //   };

  //   handleCashfreeRedirect();
  // }, []);
// ==================== CASHFREE PAYMENT VERIFICATION AFTER REDIRECT ====================
// useEffect(() => {
//   const checkCashfreeStatusAfterRedirect = async () => {
//     const savedOrder = localStorage.getItem('pending_cashfree_order');
    
//     if (savedOrder) {
//       const parsedOrder = JSON.parse(savedOrder);
      
//       setIsProcessingPayment(true);
//       setPaymentStatus('processing');
//       setPaymentStatusMessage('Verifying payment status...');

//       try {
//         // Check payment status using your API
//         const result = await checkPaymentStatus(parsedOrder.orderId);
        
//         if (result.success) {
//           setPaymentStatus('success');
//           setPaymentStatusMessage('Payment successful! Activating your plan...');
          
//           await createBusinessModuleAfterPayment({
//             ...parsedOrder.paymentData,
//             transactionId: result.transactionData.transaction_uid || parsedOrder.orderId,
//             status: "Paid"
//           });
          
//         } else {
//           setPaymentStatus('failed');
//           setPaymentStatusMessage('Payment verification failed. Please contact support.');
//         }
//       } catch (err) {
//         console.error('Error verifying payment:', err);
//         setPaymentStatus('error');
//         setPaymentStatusMessage('Error verifying payment status.');
//       } finally {
//         // Clean up localStorage regardless of outcome
//         localStorage.removeItem('pending_cashfree_order');
//       }
//     }
//   };

//   checkCashfreeStatusAfterRedirect();
// }, [dispatch]); // dispatch dependency
useEffect(() => {
  const checkCashfreeStatusAfterRedirect = async () => {
    const savedOrder = localStorage.getItem('pending_cashfree_order');
    
    if (savedOrder) {
      const parsedOrder = JSON.parse(savedOrder);
      setIsProcessingPayment(true);
      setPaymentStatus('processing');

      try {
        const result = await checkPaymentStatus(parsedOrder.orderId);
        
        if (result.success) {
          // Success hone par wahi logic call karein jo upar fix kiya hai
          await createBusinessModuleAfterPayment({
            ...parsedOrder.paymentData,
            transactionId: result.transactionData.transaction_uid || parsedOrder.orderId,
            status: "Paid"
          });
        } else {
          setPaymentStatus('failed');
          setPaymentStatusMessage('Verification failed. If amount was deducted, contact support.');
        }
      } catch (err) {
        setPaymentStatus('error');
      } finally {
        localStorage.removeItem('pending_cashfree_order');
      }
    }
  };
  checkCashfreeStatusAfterRedirect();
}, [dispatch]);
  // ==================== POLLING FUNCTION WITH TIMEOUT ====================

  const pollPaymentStatusWithTimeout = (orderId, timeoutMs = 60000) => {
    return new Promise((resolve) => {
      const startTime = Date.now();
      const pollInterval = 3000;
      let pollCount = 0;
      const maxPolls = timeoutMs / pollInterval;

      log(`🔄 Starting payment polling for ${timeoutMs/1000} seconds`, { orderId, pollInterval, maxPolls });

      const poll = async () => {
        pollCount++;
        const elapsed = Date.now() - startTime;
        
        try {
          const result = await checkPaymentStatus(orderId);
          
          if (result.success) {
            log(`✅ Payment found after ${pollCount} attempts (${elapsed}ms)`, result.transactionData);
            resolve({ success: true, transactionData: result.transactionData });
            return;
          }

          if (elapsed >= timeoutMs) {
            log(`⏰ Payment polling timeout after ${pollCount} attempts (${elapsed}ms)`);
            resolve({ 
              success: false, 
              timeout: true, 
              error: 'Payment verification timeout after 1 minute' 
            });
            return;
          }

          log(`🔄 Polling attempt ${pollCount}/${maxPolls} - Payment not found yet (${elapsed}ms elapsed)`);
          setTimeout(poll, pollInterval);
          
        } catch (error) {
          log(`❌ Polling attempt ${pollCount} failed:`, error);
          
          if (Date.now() - startTime >= timeoutMs) {
            resolve({ 
              success: false, 
              timeout: true, 
              error: 'Payment verification timeout with errors' 
            });
          } else {
            setTimeout(poll, pollInterval);
          }
        }
      };

      poll();
    });
  };



  // Helper function to update user with current plan information
// const updateUserWithPlanInfo = async (planData) => {
//   try {
//     log('👤 Updating user with current plan info', planData);
    
//     const userUpdateData = {
//       hospitalID: hospitalID,
//       subscription_status: 'active',
//       Subscription_type: planData.businessType,
//       // plan_valid_from: planData.valid_From,
//       // plan_valid_to: planData.valid_To,
//       // last_plan_update: new Date().toISOString()
//     };
    
//     log('📤 Updating user with plan data', userUpdateData);
//     await dispatch(updateUser(userUpdateData));
    
//     log('✅ User updated with current plan info');
//   } catch (error) {
//     log('❌ Error updating user with plan info', error, 'error');
//     // Don't show error to user as this is a background process
//   }
// };
  // ==================== CREATE PENDING BUSINESS MODULE ====================
const updateUserWithPlanInfo = async (planData) => {
  try {
    const fullPayload = prepareCleanUserPayload('active', planData.businessType);
    if (fullPayload) {
      log('👤 Updating user with Full Payload (Active)', fullPayload);
      // Make sure token is not in the payload when dispatching
      await dispatch(updateUser(fullPayload));
    }
  } catch (error) {
    log('❌ Error updating user info', error);
  }
};
  const createPendingBusinessModule = async (paymentInfo) => {
    try {
      const {
        ourInternalPaymentData,
        orderId
      } = paymentInfo;

      const {
        planType,
        planId,
        addons,
        basePlanValidity,
        addonValidity,
        amount,
        isModification,
        isPlanSwitch,
        proRataDetails
      } = ourInternalPaymentData;

      log('📝 Creating pending business module record', { paymentInfo });

      const basePayload = createBasePlanPayload(
        planType, 
        planId, 
        addons, 
        basePlanValidity, 
        amount, 
        orderId, 
        'Pending'
      );

      const pendingPayload = {
        ...basePayload,
        payment_status: 'pending',
        gateway_order_id: orderId,
        verification_attempts: 1,
        last_verification_check: new Date().toISOString()
      };

      log("📤 Creating pending business module with payload", pendingPayload);
      
      await dispatch(createBusinessModule(pendingPayload));

      if (addons && addons.length > 0) {
        await createPendingAddons(addons, addonValidity, orderId, planType);
      }

      paymentInfo.statusChecked = true;
      localStorage.setItem('cashfreePendingPayment', JSON.stringify(paymentInfo));

      lastSelectedPlanRef.current = {
        planType: planType,
        planId: planId,
        isModification: isModification || false
      };

      setLocalSuccess(true);

      log('✅ Pending business module created successfully');

    } catch (error) {
      log("❌ Error creating pending business module", error, 'error');
      throw new Error("Failed to create pending record. Please contact support.");
    }
  };

  // ==================== CREATE PENDING ADDONS ====================

  const createPendingAddons = async (addonIds, validity, transactionId, planType) => {
    const addons = getAddonPackages();
    const existingAddons = getExistingAddons();
    const newAddons = addonIds.filter(addonId => !existingAddons.includes(addonId));

    log('📦 Creating pending addons', {
      newAddons,
      validity,
      transactionId
    });

    for (const addonId of newAddons) {
      const addonData = addons[addonId];
      if (addonData) {
        const addonAmount = addonData.price * validity;
        const addonPayload = createAddonPayload(
          addonId,
          addonData,
          validity,
          addonAmount,
          transactionId,
          planType
        );

        const pendingAddonPayload = {
          ...addonPayload,
          payment_status: 'pending',
          gateway_order_id: transactionId
        };

        log('💾 Creating pending business addon', pendingAddonPayload);
        await dispatch(createBusinessAddon(pendingAddonPayload));
      }
    }

    log('✅ Pending addons creation completed', { newAddonsCount: newAddons.length });
  };

  useEffect(() => {
    const loadDynamicData = async () => {
      try {
        log('🔄 Loading dynamic data including addons');
        setIsLoadingDynamicData(true);

        await Promise.all([
          dispatch(getAllBusinessModels()),
          dispatch(getAllAddonPackages()),
          dispatch(getBusinessModule({ hospitalID: parseInt(hospitalID) })),
          dispatch(getAllDiscounts()),
          dispatch(getBusinessAddons({ hospitalID: parseInt(hospitalID) }))
        ]);

        log('✅ Dynamic data loaded successfully');
      } catch (error) {
        // log('❌ Error loading dynamic data', error, 'error');
        // showError('Failed to load plan options. Please try again.');
      } finally {
        setIsLoadingDynamicData(false);
      }
    };

    loadDynamicData();
  }, [dispatch, hospitalID, realTimeUpdates]);

  useEffect(() => {
    log('🔄 Processing business modules and addons on data change', {
      businessModules: businessModules?.length,
      businessAddons: businessAddons?.length
    });

    if (businessModules && businessAddons) {
      processBusinessModules();
    }
  }, [businessModules, businessAddons, hospitalID]);

// Handle success state
useEffect(() => {
    const shouldReload = success || localSuccess;
 
    if (shouldReload && lastSelectedPlanRef.current) {
        setIsProcessingPayment(true);
        setPaymentStatus('processing');
        setPaymentStatusMessage('Account activated! Redirecting...');
 
        dispatch(clearBusinessModuleSuccess());
        dispatch(clearBusinessModuleError());
 
        localStorage.removeItem('pending_cashfree_order');
        localStorage.removeItem('cashfreePendingPayment');
 
        // ✅ IMPORTANT: Reload ki jagah sirf redirect karo
        // Redux already update ho gaya hai updateSubscriptionStatus se
        // Isliye page reload ki zarurat nahi
        setTimeout(() => {
            window.location.href = window.location.href.split('#')[0] + '#/doctor/dashboard';
            // Agar phir bhi sidebar update nahi hoti toh reload uncomment karo:
            // window.location.reload();
        }, 2000);
    }
}, [success, localSuccess, dispatch]);
// useEffect(() => {
//   const shouldReload = success || localSuccess;
  
//   if (shouldReload && lastSelectedPlanRef.current) {
//     setIsProcessingPayment(true);
//     setPaymentStatus('processing');
//     setPaymentStatusMessage('Account activated! Refreshing...');

//     // Clear flags
//     dispatch(clearBusinessModuleSuccess());
//     dispatch(clearBusinessModuleError());
    
//     // Cleanup
//     localStorage.removeItem('pending_cashfree_order');
//     localStorage.removeItem('cashfreePendingPayment');
    
//     setTimeout(() => {
//       window.location.href = window.location.href.split('#')[0] + '#/doctor/dashboard';
//       window.location.reload();
//     }, 2000);
//   }
// }, [success, localSuccess, dispatch]);
// useEffect(() => {
//   const shouldReload = success || localSuccess;
  
//   if (shouldReload && lastSelectedPlanRef.current) {
//     setIsProcessingPayment(true);
//     setPaymentStatus('success');
//     setPaymentStatusMessage('Account activated! Page is refreshing to unlock sidebar...');

//     setTimeout(() => {
//       // Cleanup local storage
//       localStorage.removeItem('pending_cashfree_order');
      
//       // Hard refresh: clean URL ke sath
//       const cleanUrl = window.location.href.split('#')[0] + '#/doctor/dashboard';
//       window.location.href = cleanUrl;
//       window.location.reload(true); 
//     }, 3000); 
//   }
// }, [success, localSuccess, dispatch]);
// useEffect(() => {
//   const shouldReload = success || localSuccess;
  
//   if (shouldReload && lastSelectedPlanRef.current) {
//     const { planType, isModification, planId } = lastSelectedPlanRef.current;

//     log('✅ Plan activation successful - triggering reload', { 
//       success, 
//       localSuccess, 
//       lastSelectedPlanRef: lastSelectedPlanRef.current 
//     });

//     if (window.reloadTimeout) {
//       clearTimeout(window.reloadTimeout);
//     }

//     localStorage.setItem('app_loading', 'true');

//     const successMessage = `${isModification ? 'Plan updated' : 'Plan activated'} successfully! Refreshing application...`;
//     showSuccess(successMessage);

//     // ✅ Ensure user data is updated before reload
//     const updateUserBeforeReload = async () => {
//       try {
//         const userUpdateData = {
//           hospitalID: hospitalID,
//           subscription_status: 'active',
//           Subscription_type: planType,
//           last_plan_update: new Date().toISOString()
//         };
        
//         log('👤 Final user update before reload', userUpdateData);
//         await dispatch(updateUser(userUpdateData));
//       } catch (error) {
//         log('⚠️ User update before reload failed, continuing...', error);
//       }
//     };

//     dispatch(clearBusinessModuleSuccess());
//     dispatch(clearBusinessModuleError());
    
//     setLocalError('');
//     setLocalSuccess(false);
//     setIsActivating(false);
//     setIsProcessingPayment(false);
//     setShowPaymentModal(false);

//     const refreshData = async () => {
//       try {
//         await updateUserBeforeReload();
        
//         await Promise.all([
//           dispatch(getBusinessModule({ hospitalID: parseInt(hospitalID) })),
//           dispatch(getBusinessAddons({ hospitalID: parseInt(hospitalID) })),
//           dispatch(getAllBusinessModels()),
//           dispatch(getAllAddonPackages())
//         ]);
//         log('✅ All data refreshed before reload');
//       } catch (error) {
//         log('⚠️ Some data refresh failed, continuing with reload', error);
//       }
//     };

//     refreshData().finally(() => {
//       window.reloadTimeout = setTimeout(() => {
//         log('🔄 Performing full application reload...');

//         setTimeout(() => {
//           localStorage.removeItem('app_loading');
//         }, 1000);

//         window.location.href = window.location.href.split('#')[0] + '#/doctor/plan-selection';
//         window.location.reload();
//       }, 2000);
//     });

//     lastSelectedPlanRef.current = null;
//   }
// }, [success, localSuccess, onPlanSelected, dispatch, hospitalID]);
// useEffect(() => {
//     const checkRedirect = async () => {
//         const savedOrder = localStorage.getItem('pending_cashfree_order');
//         if (savedOrder) {
//             const parsed = JSON.parse(savedOrder);
//             // API se check karein ki transaction status 'success' hai ya nahi
//             // Agar success hai toh:
//             await createBusinessModuleAfterPayment(parsed.paymentData);
//         }
//     };
//     checkRedirect();
// }, []);
  // Fetch payment gateways
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      log('❌ No token found for payment gateway fetch');
      return;
    }

    const fetchGateways = async () => {
      try {
        log('🔄 Fetching payment gateways');
        const res = await fetch(`${baseURL}/api/appointmentPaymentSettings/getActive`, {
          method: "POST",
          body: JSON.stringify({ hid: "2" }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await res.json();
        log('💰 Payment gateways response', data);

        if (data.success && Array.isArray(data.data)) {
          setGateways(data.data);
          if (data.data.length > 0) {
            setSelectedGateway(data.data[0]);
          }
          log('✅ Payment gateways set successfully', data.data);
        } else {
          setGateways(["razorpay"]);
          setSelectedGateway("razorpay");
          log('⚠️ Using default payment gateway razorpay');
        }
      } catch (error) {
        log('❌ Error fetching payment gateways', error, 'error');
        setGateways(["razorpay"]);
        setSelectedGateway("razorpay");
      }
    };
    fetchGateways();
  }, []);

  // Reset validities when plan changes
  useEffect(() => {
    if (selectedPlan) {
      log('🔄 Resetting validities on plan change', { selectedPlan });
      setBasePlanValidity(1);
      setAddonValidity(1);
    }
  }, [selectedPlan]);

  // Initialize selected addons with existing ones when entering modification mode
  useEffect(() => {
    if (modificationMode) {
      const existingAddons = getExistingAddons();
      setSelectedAddons(existingAddons);
      log('🎯 Modification mode initialized with existing addons', existingAddons);
    }
  }, [modificationMode]);

  // ==================== PLAN PROCESSING ====================

  const processBusinessModules = () => {
    log('🔄 Processing business modules and addons');
  
    const safeBusinessModules = Array.isArray(businessModules) ? businessModules : [];
    const hospitalPlans = safeBusinessModules.filter(plan => {
      if (!plan || !plan.hospitalID) return false;
      return parseInt(plan.hospitalID) === parseInt(hospitalID);
    });
     if (!businessModules || businessModules.length === 0) {
      setCurrentPlan(null);
      updateUserForNoPlan(); // Is function ko call karein taaki user table 'inactive' ho jaye
      return;
    }

    const activeBusinessAddons = getActiveBusinessAddons();
    log('📦 Active business addons for processing', activeBusinessAddons);
  
    const { activeSubscriptionPlans, activeCommissionPlans } = filterActivePlans(hospitalPlans);
  
    setPlanHistory(hospitalPlans);
  
    const allActivePlans = [...activeSubscriptionPlans, ...activeCommissionPlans];
  
    if (allActivePlans.length > 0) {
      const sortedActivePlans = allActivePlans.sort((a, b) => (b.id || 0) - (a.id || 0));
      const mostRecentActivePlan = sortedActivePlans[0];
  
      const currentPlanData = {
        ...mostRecentActivePlan,
        isLastSelected: true,
        timestamp: new Date().toISOString(),
        planName: mostRecentActivePlan.planName || getPlanNameFromData(mostRecentActivePlan),
        validityPeriod: mostRecentActivePlan.validityPeriod || 1
      };
  
      setCurrentPlan(currentPlanData);
      log('✅ Current plan set from active plans', currentPlanData);
  
      // ✅ Update user with current active plan info
      updateUserWithPlanInfo(currentPlanData);
  
      const activeAddonIds = getExistingAddons();
      setSelectedAddons(activeAddonIds);
      log('🎯 Setting selected addons from business_addons', activeAddonIds);
  
      return;
    }
  
    const savedLastPlan = localStorage.getItem('lastSelectedPlan');
    if (savedLastPlan) {
      try {
        const lastPlan = JSON.parse(savedLastPlan);
        if (lastPlan && lastPlan.planName && lastPlan.businessType) {
          setCurrentPlan(lastPlan);
          log('✅ Current plan set from localStorage', lastPlan);
          
          // ✅ Update user with saved plan info
          updateUserWithPlanInfo(lastPlan);
        }
      } catch (error) {
        localStorage.removeItem('lastSelectedPlan');
        setCurrentPlan(null);
        log('❌ Error parsing saved plan from localStorage', error, 'error');
        
        // ✅ Update user for no active plan
        updateUserForNoPlan();
      }
    } else {
      setCurrentPlan(null);
      log('📝 No current plan found');
      
      // ✅ Update user for no active plan
      updateUserForNoPlan();
    }
  };

  const filterActivePlans = (hospitalPlans) => {
    const commissionPlans = hospitalPlans.filter(plan =>
      plan && plan.businessType === 'commission'
    );
    const subscriptionPlans = hospitalPlans.filter(plan =>
      plan && plan.businessType === 'subscription'
    );

    const activeSubscriptionPlans = subscriptionPlans.filter(plan => {
      const validToDate = parseDate(plan.valid_To);
      const isActive = validToDate && validToDate > new Date();
      log('📅 Subscription plan validity check', { plan: plan.id, valid_To: plan.valid_To, validToDate, isActive });
      return isActive;
    });

    const activeCommissionPlans = commissionPlans.filter(plan => {
      if (!plan.valid_To) {
        log('📅 Commission plan with no expiry', { plan: plan.id });
        return true;
      }
      const validToDate = parseDate(plan.valid_To);
      const isActive = !validToDate || validToDate > new Date();
      log('📅 Commission plan validity check', { plan: plan.id, valid_To: plan.valid_To, validToDate, isActive });
      return isActive;
    });

    const result = {
      activeSubscriptionPlans,
      activeCommissionPlans,
      allActivePlans: [...activeSubscriptionPlans, ...activeCommissionPlans]
    };

    log('✅ Active plans filtered', result);
    return result;
  };

  // ==================== UTILITY FUNCTIONS ====================
  
  const getBusinessPlans = () => {
    if (!businessModels || businessModels.length === 0) {
      log('❌ No business models available');
      return [];
    }

    const plans = businessModels.filter(model => model.status === 'active').map(model => {
      const isSubscription = model.module_name?.toLowerCase().includes('subscription');
      const isCommission = model.module_name?.toLowerCase().includes('commission');

      const displayPrice = model.priceType === 'Percent' ?
        parseFloat(model.price) || 15 :
        parseFloat(model.price) || 0;

      const facilities = model.facilities ?
        model.facilities.split(',').map(f => f.trim()).filter(f => f.length > 0) : [];

      return {
        id: model.id,
        name: model.module_name,
        price: displayPrice,
        period: 'month',
        features: facilities,
        type: isSubscription ? 'subscription' : isCommission ? 'commission' : 'other',
        popular: false,
        modelData: model,
        priceType: model.priceType,
        facilities: facilities
      };
    });

    log('📊 Business plans processed', { count: plans.length, plans });
    return plans;
  };

  // Enhanced Plan Card Component
  const PlanCard = ({ plan, isCurrentPlanType, onSelect, onModify }) => {
    const [showAllFeatures, setShowAllFeatures] = useState(false);

    const previewFeatures = plan.features.slice(0, 3);
    const hasMoreFeatures = plan.features.length > 3;

    return (
      <div className="col-lg-5 mb-4">
        <div className="card h-100 border-light shadow-sm plan-card">
          <div className="card-body p-4 d-flex flex-column">
            {/* Plan Header */}
            <div className="text-center mb-3">
              <h5 className="card-title text-dark mb-2">{plan.name}</h5>

              {plan.type === 'subscription' ? (
                <div className="mb-3">
                  <span className="h3 text-dark fw-bold">₹{plan.price}</span>
                  <span className="text-muted">/month</span>
                  <div className="mt-2">
                    <span className="badge bg-info">Fixed Monthly Price</span>
                  </div>
                </div>
              ) : (
                <div className="mb-3">
                  <span className="h3 text-dark fw-bold">{plan.price}%</span>
                  <span className="text-muted"> commission</span>
                  <div className="mt-2">
                    <span className="badge bg-success">Pay Per Use</span>
                  </div>
                </div>
              )}
            </div>

            {/* Features List */}
            <div className="mb-3 flex-grow-1">
              <h6 className="text-muted mb-2">
                <i className="fas fa-list-check me-2"></i>
                Included Features:
              </h6>

              <div className="features-list">
                {previewFeatures.map((feature, index) => (
                  <div key={index} className="d-flex align-items-start mb-2">
                    <i className="fas fa-check-circle text-success mt-1 me-2" style={{ fontSize: '0.8rem' }}></i>
                    <small className="text-dark">{feature}</small>
                  </div>
                ))}

                {hasMoreFeatures && !showAllFeatures && (
                  <button
                    className="btn btn-link btn-sm p-0 text-info"
                    onClick={() => setShowAllFeatures(true)}
                  >
                    <small>+ {plan.features.length - 3} more features</small>
                  </button>
                )}

                {showAllFeatures && plan.features.slice(3).map((feature, index) => (
                  <div key={index + 3} className="d-flex align-items-start mb-2">
                    <i className="fas fa-check-circle text-success mt-1 me-2" style={{ fontSize: '0.8rem' }}></i>
                    <small className="text-dark">{feature}</small>
                  </div>
                ))}

                {showAllFeatures && (
                  <button
                    className="btn btn-link btn-sm p-0 text-info"
                    onClick={() => setShowAllFeatures(false)}
                  >
                    <small>Show less</small>
                  </button>
                )}
              </div>
            </div>

            {/* Additional Info */}
            <div className="mb-3">
              <small className="text-muted d-block">
                <i className="fas fa-info-circle me-1"></i>
                {plan.type === 'subscription'
                  ? 'All features included + optional paid modules'
                  : 'Free base plan + optional paid modules'
                }
              </small>

              {plan.type === 'subscription' && getValidityOptions().some(opt => opt.discount > 0) && (
                <small className="text-success d-block mt-1">
                  <i className="fas fa-tag me-1"></i>
                  Save up to {Math.max(...getValidityOptions().map(opt => opt.discount))}% with longer validity
                </small>
              )}
            </div>

            {/* Action Button */}
            <div className="mt-auto">
              {isCurrentPlanType ? (
                <button
                  className="btn btn-info rounded-pill w-100"
                  onClick={onModify}
                >
                  <i className="fas fa-edit me-2"></i>Modify Current Plan
                </button>
              ) : (
                <button
                  className="btn btn-info rounded-pill w-100"
                  onClick={onSelect}
                >
                  <i className="fas fa-check me-2"></i>Select Plan
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const getSelectedPlanDetails = () => {
    if (!selectedPlanId) {
      log('❌ No selected plan ID');
      return null;
    }

    const plan = getBusinessPlans().find(plan => plan.id === selectedPlanId);
    log('🔍 Selected plan details', { selectedPlanId, plan });
    return plan;
  };

  const getPlanNameFromData = (planData) => {
    if (planData.planName) {
      log('📝 Plan name from planData', planData.planName);
      return planData.planName;
    }

    const businessPlans = getBusinessPlans();
    const matchingPlan = businessPlans.find(plan => plan.type === planData.businessType);
    const planName = matchingPlan?.name || (planData.businessType === 'subscription' ? 'Subscription' : 'Commission');

    log('📝 Derived plan name', { businessType: planData.businessType, planName });
    return planName;
  };

  const canSwitchToPlan = (planType) => {
    if (!currentPlan) {
      log('✅ Can switch - no current plan');
      return true;
    }

    if (currentPlan.businessType === planType) {
      log('✅ Can switch - same plan type');
      return true;
    }

    log('⚠️ Plan switch requires confirmation', { from: currentPlan.businessType, to: planType });
    return true;
  };

  const isModifyingCurrentPlan = () => {
    if (!currentPlan || !selectedPlan) {
      log('🔍 Modification check: no current plan or selected plan', { currentPlan, selectedPlan });
      return false;
    }

    const isModifying = currentPlan.businessType === selectedPlan;
    log('🔍 Modification check result', { currentPlan: currentPlan.businessType, selectedPlan, isModifying });
    return isModifying;
  };

  // ==================== SELECTED FEATURES CALCULATION ====================

  const getSelectedFeatures = () => {
    const selectedPlanData = getSelectedPlanDetails();
    if (!selectedPlanData) {
      log('❌ No selected plan data for features calculation');
      return null;
    }

    const isModification = isModifyingCurrentPlan();
    const isPlanSwitch = currentPlan && currentPlan.businessType !== selectedPlan;
    const currentBaseValidityOption = getCurrentBaseValidityOption();
    const currentAddonValidityOption = getCurrentAddonValidityOption();

    log('🔍 Getting selected features', {
      selectedPlan,
      isModification,
      isPlanSwitch,
      currentBaseValidityOption,
      currentAddonValidityOption
    });

    if (selectedPlan === 'subscription') {
      const subscriptionCalculation = calculateSubscriptionTotal();
      const { addonTotal, addonSavings, addonDiscount, newAddons, proRataDetails, isProRata, shouldCharge } = calculateAddonTotal();
      const existingAddons = getExistingAddons();

      const result = {
        type: 'subscription',
        name: selectedPlanData.name,
        price: selectedPlanData.price,
        baseTotal: subscriptionCalculation.basePrice,
        baseSavings: subscriptionCalculation.baseSavings,
        baseDiscount: subscriptionCalculation.baseDiscount,
        addonTotal,
        addonSavings,
        addonDiscount,
        total: subscriptionCalculation.total,
        basePlanValidity: isModification ? 1 : basePlanValidity,
        addonValidity: addonValidity,
        features: selectedPlanData.features || [],
        addons: selectedAddons.map(addonId => getAddonPackages()[addonId]).filter(Boolean),
        isModification,
        isPlanSwitch,
        newAddons: newAddons || [],
        existingAddons: existingAddons || [],
        planId: selectedPlanData.id,
        proRataDetails,
        isProRata,
        shouldCharge: shouldCharge,
        newAddonsCount: newAddons?.length || 0,
        onlyNewModules: isModification,
        originalBasePrice: selectedPlanData.price,
        currentBaseValidityOption: isModification ? null : currentBaseValidityOption,
        currentAddonValidityOption: currentAddonValidityOption
      };

      log('✅ Subscription features calculated', result);
      return result;
    } else if (selectedPlan === 'commission') {
      const addons = getAddonPackages();
      const baseFeatures = [...(selectedPlanData.features || [])];

      const commissionCalculation = calculateCommissionTotal();
      const existingAddons = getExistingAddons();
      const isPlanSwitch = currentPlan && currentPlan.businessType !== selectedPlan;

      const commissionRate = selectedPlanData.modelData?.priceType === 'Percent' ?
        selectedPlanData.price : 15;

      const result = {
        type: 'commission',
        name: selectedPlanData.name,
        rate: commissionRate,
        features: [...baseFeatures],
        addons: selectedAddons.map(addonId => addons[addonId]).filter(Boolean),
        addonTotal: commissionCalculation.addonTotal,
        addonSavings: commissionCalculation.addonSavings,
        addonDiscount: commissionCalculation.addonDiscount,
        total: commissionCalculation.total,
        basePlanValidity: 0,
        addonValidity: addonValidity,
        isModification,
        isPlanSwitch: isPlanSwitch,
        newAddons: commissionCalculation.newAddons || [],
        existingAddons: existingAddons || [],
        planId: selectedPlanData.id,
        proRataDetails: commissionCalculation.proRataDetails,
        isProRata: commissionCalculation.isProRata,
        hasAddons: selectedAddons.length > 0,
        shouldCharge: commissionCalculation.shouldCharge,
        newAddonsCount: commissionCalculation.newAddonsCount || 0,
        currentAddonValidityOption: currentAddonValidityOption
      };

      log('✅ Commission features calculated', result);
      return result;
    }

    log('❌ Unknown plan type for features calculation', selectedPlan);
    return null;
  };

  // ==================== EVENT HANDLERS ====================

  const handlePlanSelect = (planId, planType) => {
    log('🎯 Plan selected attempt', { planId, planType, currentPlan });

    if (!canSwitchToPlan(planType)) {
      const errorMsg = `You cannot switch to ${planType} plan until your current plan expires`;
      showError(errorMsg);
      log('❌ Plan switch not allowed', errorMsg);
      return;
    }

    if (currentPlan && currentPlan.businessType !== planType) {
      let message = '';

      if (currentPlan.businessType === 'commission' && planType === 'subscription') {
        message = 'Switching to Subscription plan requires payment for base subscription. Your existing paid addons will remain active. Proceed?';
      } else if (currentPlan.businessType === 'subscription' && planType === 'commission') {
        message = 'Switching to Commission plan - no base payment required. Your existing paid addons will remain active. Proceed?';
      } else {
        message = `Switching from ${currentPlan.businessType} to ${planType} plan. Your existing paid addons will remain active. Proceed?`;
      }

      setSelectedPlanId(planId);
      setConfirmMessage(message);
      setShowConfirmUpgrade(true);
      log('⚠️ Plan switch confirmation required', { message });
      return;
    }

    proceedToPlanSelection(planId, planType);
  };

  const proceedToPlanSelection = (planId, planType) => {
    const isModification = currentPlan && currentPlan.businessType === planType;

    log('✅ Proceeding to plan selection', { planId, planType, isModification });

    setIsModifyingExisting(isModification);
    setSelectedPlan(planType);
    setSelectedPlanId(planId);
    setLocalError('');
    setShowConfirmUpgrade(false);
    setConfirmMessage('');

    const existingAddons = getExistingAddons();
    setSelectedAddons(existingAddons);
    log('🎯 Carrying over existing paid addons', existingAddons);

    if (isModification) {
      setBasePlanValidity(1);
      setAddonValidity(1);
      log('🔄 Resetting validities for modification mode');
    }
  };

  const handleAddonToggle = addonId => {
    const isExisting = checkIfAddonActive(addonId);

    if (isExisting) {
      log('🚫 Cannot toggle addon - already active', addonId);
      return;
    }

    setSelectedAddons(prev => {
      const newSelection = prev.includes(addonId)
        ? prev.filter(id => id !== addonId)
        : [...prev, addonId];

      log('🔄 Addon toggle', { addonId, wasSelected: prev.includes(addonId), newSelection });
      return newSelection;
    });
  };

  // ==================== MODIFICATION HANDLERS ====================

  const handleModifyPlan = () => {
    log('🔧 Entering modification mode');
    setModificationMode(true);
    setSelectedPlan(currentPlan.businessType);

    const currentPlanTypePlan = getBusinessPlans().find(
      plan => plan.type === currentPlan.businessType
    );

    if (currentPlanTypePlan) {
      setSelectedPlanId(currentPlanTypePlan.id);
    }

    const existingAddons = getExistingAddons();
    setSelectedAddons(existingAddons);

    setBasePlanValidity(1);
    setAddonValidity(1);
  };

  const handleCancelModification = () => {
    log('❌ Cancelling modification');
    setModificationMode(false);
    setSelectedPlan(null);
    setSelectedPlanId(null);
    setSelectedAddons([]);
  };

  const handleFinalizeSelection = async () => {
    log('🚀 Finalizing plan selection');
  
    if (!selectedPlan || !selectedPlanId) {
      const errorMsg = 'Please select a plan';
      showError(errorMsg);
      log('❌ Finalize selection failed', errorMsg);
      return;
    }
  
    try {
      setLocalError('');
  
      const selection = getSelectedFeatures();
      if (!selection) {
        throw new Error("Could not calculate plan details");
      }
  
      const isPlanSwitch = selection.isPlanSwitch;
      let requiresPayment = false;
  
      if (selectedPlan === 'subscription') {
        requiresPayment = selection.total > 0;
      } else if (selectedPlan === 'commission') {
        requiresPayment = selection.shouldCharge && selection.total > 0;
      }
  
      log('💰 Payment requirement check', {
        selectedPlan,
        total: selection.total,
        shouldCharge: selection.shouldCharge,
        isPlanSwitch,
        requiresPayment,
        selection
      });
  
      if (requiresPayment) {
        setPendingPaymentData({
          planType: selectedPlan,
          planId: selectedPlanId,
          addons: selectedAddons,
          basePlanValidity: basePlanValidity,
          addonValidity: addonValidity,
          amount: selection.total,
          isModification: isModifyingExisting || isModifyingCurrentPlan(),
          isPlanSwitch: isPlanSwitch,
          proRataDetails: selection.proRataDetails,
          isProRata: selection.isProRata
        });
        setShowPaymentModal(true);
        log('💰 Payment required, showing payment modal', pendingPaymentData);
      } else {
        if (selection.newAddonsCount === 0) {
          log('🆓 No payment required (no new addons), activating plan directly');
          await activatePlanWithoutPayment();
        } else {
          log('❌ Payment required but not triggered', selection);
          showError('Payment required for selected modules. Please try again.');
        }
      }
  
    } catch (error) {
      log('❌ Failed to process plan selection', error, 'error');
      showError('Failed to process plan selection. Please try again.');
    }
  };
// const activatePlanWithoutPayment = async () => {
//     try {
//         setIsActivating(true);
 
//         const payload = createBasePlanPayload();
//         lastSelectedPlanRef.current = {
//             planType: selectedPlan,
//             planId: selectedPlanId,
//             isModification: isModifyingExisting || isModifyingCurrentPlan()
//         };
 
//         await dispatch(createBusinessModule(payload));
 
//         if (selectedPlan === 'commission') {
//             await handleAddonActivation('FREE_ACTIVATION', 'Active');
//         }
 
//         await dispatch(getBusinessModule({ hospitalID: parseInt(hospitalID) }));
//         await dispatch(getBusinessAddons({ hospitalID: parseInt(hospitalID) }));
 
//         // ✅ YE ADD KARO — Redux update karo
//         dispatch(updateSubscriptionStatus('active', selectedPlan));
//         console.log('[PlanSelection] Free activation — subscription updated in Redux');
 
//         setLocalSuccess(true);
 
//     } catch (error) {
//         showError('Failed to activate plan. Please try again.');
//     } finally {
//         setIsActivating(false);
//     }
// };
 
 
  // const activatePlanWithoutPayment = async () => {
  //   try {
  //     setIsActivating(true);
  //     log('🔄 Activating plan without payment');
  
  //     const payload = createBasePlanPayload();
  //     lastSelectedPlanRef.current = {
  //       planType: selectedPlan,
  //       planId: selectedPlanId,
  //       isModification: isModifyingExisting || isModifyingCurrentPlan()
  //     };
  
  //     log('📤 Activating plan without payment - base payload', payload);
  
  //     await dispatch(createBusinessModule(payload));
  
  //     if (selectedPlan === 'commission') {
  //       await handleAddonActivation('FREE_ACTIVATION', 'Active');
  //     }
  
  //     await dispatch(getBusinessModule({ hospitalID: parseInt(hospitalID) }));
  //     await dispatch(getBusinessAddons({ hospitalID: parseInt(hospitalID) }));
  
  //     // ✅ ALWAYS update user after plan activation
  //     const userUpdateData = {
  //       hospitalID: hospitalID,
  //       subscription_status: 'active',
  //       Subscription_type: selectedPlan,
      
  //     };
      
  //     log('👤 Updating user after plan activation', userUpdateData);
  //     await dispatch(updateUser(userUpdateData));
  
  //     log('✅ Plan activated successfully without payment');
  //     setLocalError('');
  
  //     setLocalSuccess(true);
  
  //   } catch (error) {
  //     log('❌ Failed to activate plan', error, 'error');
  //     showError('Failed to activate plan. Please try again.');
  //   } finally {
  //     setIsActivating(false);
  //   }
  // };
// Ye function check karta hai ki kaunse modules doctor ne naye select kiye hain
const activatePlanWithoutPayment = async () => {
    try {
        setIsActivating(true);

        const payload = createBasePlanPayload();
        lastSelectedPlanRef.current = {
            planType: selectedPlan,
            planId: selectedPlanId,
            isModification: isModifyingExisting || isModifyingCurrentPlan()
        };

        await dispatch(createBusinessModule(payload));

        if (selectedPlan === 'commission') {
            await handleAddonActivation('FREE_ACTIVATION', 'Active');
        }

        await dispatch(getBusinessModule({ hospitalID: parseInt(hospitalID) }));
        await dispatch(getBusinessAddons({ hospitalID: parseInt(hospitalID) }));

        dispatch(updateSubscriptionStatus('active', selectedPlan));
        console.log('[PlanSelection] Free activation — subscription updated in Redux');

        // ✅ SIRF YE 2 LINES ADD KARO — baaki sab same hai
        const validTo = selectedPlan === 'commission' ? null : payload.valid_To;
        await sendSubscriptionRenewalSms(selectedPlan, validTo);
        // ✅ END

        setLocalSuccess(true);

    } catch (error) {
        showError('Failed to activate plan. Please try again.');
    } finally {
        setIsActivating(false);
    }
};
const getOnlyNewSelectedAddons = () => {
    const existingIds = getExistingAddons(); // Pehle se active modules ki IDs
    const allPkgs = getAddonPackages();      // Saare available modules ki list
    
    return selectedAddons
        .filter(id => !existingIds.includes(id)) // Sirf wahi rakhein jo pehle se active nahi hain
        .map(id => ({
            id: id,
            name: allPkgs[id]?.name,
            price: allPkgs[id]?.price
        }));
};
  // Handle addon activation with payment
  const handleAddonActivation = async (transactionId, status = 'Paid') => {
    const addons = getAddonPackages();
    const existingAddons = getExistingAddons();
    const newAddons = getNewAddons();

    log('📦 Processing addon activation', {
      existing: existingAddons,
      new: newAddons,
      selected: selectedAddons,
      addonValidity,
      transactionId,
      status
    });

    for (const addonId of newAddons) {
      const addonData = addons[addonId];
      if (addonData) {
        const addonAmount = addonData.price * addonValidity;
        const addonPayload = createAddonPayload(
          addonId,
          addonData,
          addonValidity,
          addonAmount,
          transactionId,
          selectedPlan
        );

        log('💾 Creating business addon', addonPayload);
        await dispatch(createBusinessAddon(addonPayload));
      }
    }

    log('✅ Addon activation completed', { newAddonsCount: newAddons.length });
  };

  // ==================== PAYMENT HANDLING ====================

  const handlePaymentConfirm = () => {
    if (!pendingPaymentData || !selectedGateway) {
      const errorMsg = "Please select a payment method";
      showError(errorMsg);
      log('❌ Payment confirmation failed', errorMsg);
      return;
    }
  
    console.log('🔍 Debug - createRazorpayOrder:', typeof createRazorpayOrder);
    console.log('🔍 Debug - dispatch:', typeof dispatch);
    console.log('🔍 Debug - pendingPaymentData:', pendingPaymentData);
    console.log('🔍 Debug - selectedGateway:', selectedGateway);
  
    try {
      log('✅ Payment confirmation', { pendingPaymentData, selectedGateway });
      handlePayment(pendingPaymentData);
    } catch (error) {
      console.error('❌ Error in handlePaymentConfirm:', error);
      showError('Payment initialization failed. Please try again.');
    }
  };

  // const handlePayment = async (paymentData) => {
  //   setIsProcessingPayment(true);
  //   setLocalError('');
  //   log('💰 Starting payment process', paymentData);

  //   try {
  //     const { amount, planType, planId, addons, basePlanValidity, addonValidity, isModification, proRataDetails, isProRata } = paymentData;

  //     let orderPayload = {
  //       amount: amount,
  //       currency: "INR",
  //       gateway: selectedGateway,
  //       hid: "0",
  //     };

  //     if (selectedGateway === "cashfree") {
  //       const loginData = JSON.parse(localStorage.getItem("loginData") || "{}");
  //       orderPayload = {
  //         ...orderPayload,
  //         name: loginData.first_name || "User",
  //         phone: loginData.mobile || "",
  //         email: loginData.email || "",
  //         returnUrl: `${window.location.origin}/#/doctor/plan-selection`,
  //       };
  //     }

  //     log("💰 Creating payment order", orderPayload);
      
  //     const orderResult = await dispatch(createRazorpayOrder(orderPayload));
      
  //     console.log('🔍 Debug: Order result', orderResult);
      
  //     if (selectedGateway === "cashfree") {
  //       if (!orderResult || !orderResult.payment_session_id) {
  //         throw new Error("Failed to create Cashfree payment session. Please try again.");
  //       }
  //     } else {
  //       if (!orderResult || !orderResult.orderId) {
  //         throw new Error("Failed to create payment order. Please try again.");
  //       }
  //     }

  //     if (selectedGateway === "razorpay") {
  //       if (typeof window.Razorpay === 'undefined') {
  //         throw new Error("Payment system not loaded. Please refresh the page.");
  //       }

  //       const options = {
  //         key: orderResult.key,
  //         amount: orderResult.amount * 100,
  //         currency: "INR",
  //         name: "Medisevas - Plan Subscription",
  //         description: `${planType} Plan Activation${isProRata ? ' (Pro-rata)' : ''}`,
  //         order_id: orderResult.cf_order_id,
  //         handler: async (response) => {
  //           log('💰 Payment handler triggered', response);
  //           await createBusinessModuleAfterPayment({
  //             ...paymentData,
  //             transactionId: response.razorpay_payment_id,
  //             status: "Paid"
  //           });
  //         },
  //         prefill: {
  //           name: localStorage.getItem("loginData") ? JSON.parse(localStorage.getItem("loginData")).first_name : "User",
  //           email: localStorage.getItem("loginData") ? JSON.parse(localStorage.getItem("loginData")).email : "",
  //           contact: localStorage.getItem("loginData") ? JSON.parse(localStorage.getItem("loginData")).mobile : "",
  //         },
  //         theme: { color: "#321fdb" },
  //         modal: {
  //           ondismiss: () => {
  //             setIsProcessingPayment(false);
  //             setShowPaymentModal(false);
  //             showError("Payment cancelled by user.");
  //             log('❌ Payment cancelled by user');
  //           },
  //         },
  //       };

  //       const rzp = new window.Razorpay(options);
  //       rzp.open();
  //     } else if (selectedGateway === "cashfree") {
  //       if (!orderResult.payment_session_id) {
  //         throw new Error("Cashfree payment session not available. Please try again.");
  //       }
        
  //       await handleCashfreePayment(
  //         orderResult.payment_session_id,
  //         orderResult.cf_order_id || orderResult.cf_order_id,
  //         paymentData
  //       );
  //     } else {
  //       throw new Error(`Unsupported payment gateway: ${selectedGateway}`);
  //     }

  //   } catch (err) {
  //     log("❌ Payment error", err, 'error');
  //     showError(err.message || "Payment failed. Please try again.");
  //     setIsProcessingPayment(false);
  //   }
  // };

  // Handle user with no active plan
const handlePayment = async (paymentData) => {
    setIsProcessingPayment(true);
  setLocalError('');
  log('💰 Starting payment process', paymentData);

  try {
    // Sirf naye addons filter karein
    const newAddonsDetails = getOnlyNewSelectedAddons(); 
    const newAddonIds = newAddonsDetails.map(a => a.id);

    const filteredPaymentData = {
      ...paymentData,
      addons: newAddonIds,
      addonsDetails: newAddonsDetails
    };

    let orderPayload = {
      amount: paymentData.amount,
      currency: "INR",
      gateway: selectedGateway,
      hid: "0",
    };

    if (selectedGateway === "cashfree") {
      const loginData = JSON.parse(localStorage.getItem("loginData") || "{}");
      orderPayload = {
        ...orderPayload,
        name: loginData.first_name || "User",
        phone: loginData.mobile || "",
        email: loginData.email || "",
        returnUrl: `${window.location.origin}/#/doctor/plan-selection`,
      };
    }

    const orderResult = await dispatch(createRazorpayOrder(orderPayload));

    if (!orderResult || (!orderResult.orderId && !orderResult.payment_session_id)) {
      throw new Error("Failed to create payment order");
    }

    if (selectedGateway === "cashfree") {
      if (!orderResult.payment_session_id) {
        throw new Error("Cashfree payment session not available.");
      }

      // LocalStorage mein save karein
      const cashfreeDataToSave = {
        orderId: orderResult.cf_order_id || orderResult.orderId,
        paymentData: filteredPaymentData,
        hospitalID: hospitalID,
        timestamp: Date.now()
      };
      
      localStorage.setItem('pending_cashfree_order', JSON.stringify(cashfreeDataToSave));
      
      const cashfree = await initializeCashfree();
      cashfree.checkout({
        paymentSessionId: orderResult.payment_session_id,
        redirectTarget: "_self",
      });
    }

        // ==================== CASHFREE FLOW (IMPORTANT) ====================
        if (selectedGateway === "cashfree") {
            if (!orderResult.payment_session_id) {
                throw new Error("Cashfree payment session not available.");
            }

            // [SABSE JARURI]: Redirect se pehle LocalStorage mein data save karein
            // Taki wapas aane par hume pata chale ki kya kharidna tha
            const cashfreeDataToSave = {
                orderId: orderResult.cf_order_id, 
                paymentData: filteredPaymentData,
                hospitalID: hospitalID,
                timestamp: Date.now()
            };
            
            localStorage.setItem('pending_cashfree_order', JSON.stringify(cashfreeDataToSave));
            log('💾 Data saved to LocalStorage, Redirecting...');

            // Cashfree SDK load karke checkout open karein
            const cashfree = await initializeCashfree();
            cashfree.checkout({
                paymentSessionId: orderResult.payment_session_id,
                redirectTarget: "_self", // Isi window mein payment page khulega
            });
        } 
        
        // ==================== RAZORPAY FLOW ====================
        else if (selectedGateway === "razorpay") {
            if (typeof window.Razorpay === 'undefined') {
                throw new Error("Razorpay SDK not loaded. Please refresh.");
            }

            const options = {
                key: orderResult.key,
                amount: orderResult.amount * 100,
                currency: "INR",
                name: "Medisevas",
                description: "Plan Subscription",
                order_id: orderResult.orderId || orderResult.cf_order_id,
                handler: async (response) => {
                    log('💰 Razorpay Success, creating entries...');
                    
                    // Razorpay popup band hone ke baad processing dikhayein
                    setShowPaymentModal(false);
                    setIsProcessingPayment(true);

                    // Database mein entries save karein (Plan + Addons + User Unlock)
                    await createBusinessModuleAfterPayment({
                        ...filteredPaymentData,
                        transactionId: response.razorpay_payment_id,
                        status: "Paid"
                    });
                },
                modal: {
                    ondismiss: () => {
                        log('❌ Razorpay Cancelled');
                        setIsProcessingPayment(false);
                        setShowPaymentModal(false);
                    },
                },
                prefill: {
                    name: localStorage.getItem("loginData") ? JSON.parse(localStorage.getItem("loginData")).first_name : "User",
                    email: localStorage.getItem("loginData") ? JSON.parse(localStorage.getItem("loginData")).email : "",
                    contact: localStorage.getItem("loginData") ? JSON.parse(localStorage.getItem("loginData")).mobile : "",
                },
                theme: { color: "#321fdb" },
            };

            const rzp = new window.Razorpay(options);
            rzp.open();
        } 
        else {
            throw new Error(`Unsupported payment gateway: ${selectedGateway}`);
        }

    } catch (err) {
        log("❌ Payment Error:", err, 'error');
        showError(err.message || "Payment failed. Please try again.");
        setIsProcessingPayment(false); // Error par loader band karein
    }
};
const updateUserForNoPlan = async () => {
  try {
    const fullPayload = prepareCleanUserPayload('inactive', null);
    if (fullPayload) {
      log('👤 Updating user with Full Payload (Inactive)', fullPayload);
      // Make sure token is not in the payload when dispatching
      await dispatch(updateUser(fullPayload));
    }
  } catch (error) {
    log('❌ Error updating user to inactive', error);
  }
};

// const updateUserForNoPlan = async () => {
//   try {
//     const fullPayload = prepareCleanUserPayload('inactive', null);
//     if (fullPayload) {
//       log('👤 Updating user with Full Payload (Inactive)', fullPayload);
//       await dispatch(updateUser(fullPayload));
//     }
//   } catch (error) {
//     log('❌ Error updating user to inactive', error);
//   }
// };
//   const updateUserForNoPlan = async () => {
//   try {
//     log('👤 Updating user for no active plan scenario');
    
//     const userUpdateData = {
//       hospitalID: hospitalID,
//       subscription_status: 'inactive',
//       Subscription_type: null,
//       // plan_activated_date: null,
//       // last_plan_update: new Date().toISOString()
//     };
    
//     log('📤 Updating user with no plan data', userUpdateData);
//     await dispatch(updateUser(userUpdateData));
    
//     log('✅ User updated for no active plan');
//   } catch (error) {
//     log('❌ Error updating user for no plan', error, 'error');
//     // Don't show error to user as this is a background process
//   }
// };
 // Enhanced payment completion with full reload and user update
// const createBusinessModuleAfterPayment = async (paymentData) => {
//   try {
//     const {
//       planType,
//       planId,
//       addons,
//       basePlanValidity,
//       addonValidity,
//       amount,
//       transactionId,
//       status = "Paid"
//     } = paymentData;

//     log('💰 Creating business module after payment', paymentData);

//     const basePayload = createBasePlanPayload(planType, planId, addons, basePlanValidity, amount, transactionId, status);
//     log("📤 Creating business module with payload", basePayload);
//     await dispatch(createBusinessModule(basePayload));

//     await handleAddonActivation(transactionId, status);

//     // ✅ ALWAYS update user after successful payment
//     const userUpdateData = {
//       hospitalID: hospitalID,
//       subscription_status: 'active',
//       Subscription_type: planType,
//       // plan_activated_date: new Date().toISOString(),
//       // last_plan_update: new Date().toISOString(),
//       // payment_status: 'paid',
//       // transaction_id: transactionId
//     };
    
//     log('👤 Updating user after payment', userUpdateData);
//     await dispatch(updateUser(userUpdateData));

//     lastSelectedPlanRef.current = {
//       planType: planType,
//       planId: planId,
//       isModification: paymentData.isModification || false
//     };

//     setLocalSuccess(true);

//     setLocalError('');
//     setIsProcessingPayment(false);
//     setShowPaymentModal(false);

//     log('✅ Payment and plan activation completed successfully');

//   } catch (error) {
//     log("❌ Error creating business module after payment", error, 'error');
//     showError("Payment successful but failed to activate plan. Please contact support.");
//     setIsProcessingPayment(false);
//   }
// };
// const createBusinessModuleAfterPayment = async (paymentData) => {
//   const { planType, planId, addons, addonsDetails, basePlanValidity, addonValidity, amount, transactionId } = paymentData;

//   setIsProcessingPayment(true);
//   setPaymentStatus('processing');
//   setPaymentStatusMessage('Payment Verified! Syncing your account profile...');

//   try {
//     // 1. Database entries save karein
//     await dispatch(createBusinessModule(createBasePlanPayload(planType, planId, addons, basePlanValidity, amount, transactionId, "Paid")));
    
//     // Addon entries karein
//     const addonsToProcess = addonsDetails || [];
//     for (const addon of addonsToProcess) {
//        const addonPayload = {
//           hospitalID: parseInt(hospitalID),
//           addon_name: addon.name,
//           start_date: formatDateForDB(new Date()),
//           valid_date: formatDateForDB(calculateAddonEndDate(new Date(), addonValidity)),
//           amount: String(addon.price * addonValidity),
//           transactionId: transactionId,
//           status: 'active',
//           payment_status: 'Paid'
//        };
//        await dispatch(createBusinessAddon(addonPayload));
//     }

//     // 2. 🔥 AB POORA PAYLOAD BHEJEIN (Isse 500 error nahi aayegi)
//     const fullUserPayload = prepareCleanUserPayload('active', planType);
    
//     if (fullUserPayload) {
//       log("📤 Sending Full User Object to API:", fullUserPayload);
//       await dispatch(updateUser(fullUserPayload));
      
//       // LocalStorage ko update karein taki sidebar ko naya status mile
//       localStorage.setItem('loginData', JSON.stringify(fullUserPayload));
//     }

//     // 3. Success state set karein
//     lastSelectedPlanRef.current = { planType, isModification: modificationMode };
//     setLocalSuccess(true); 

//   } catch (err) {
//     log("❌ Critical Update Error:", err);
//     setPaymentStatus('error');
//     setPaymentStatusMessage('API Sync fail hua. Please refresh karein.');
//   }
// };
// PlanSelection.js ke andar is function ko update karein
// const createBusinessModuleAfterPayment = async (paymentData) => {
//   try {
//     const { planType, planId, addons, addonsDetails, basePlanValidity, addonValidity, amount, transactionId } = paymentData;

//     setIsProcessingPayment(true);
//     setPaymentStatus('processing');
//     setPaymentStatusMessage('Payment Verified! Updating your account...');

//     // 1. Plan Entry in DB
//     await dispatch(createBusinessModule(
//       createBasePlanPayload(planType, planId, addons, basePlanValidity, amount, transactionId, "Paid")
//     ));

//     // 2. Addons Entry
//     if (addonsDetails && addonsDetails.length > 0) {
//       for (const addon of addonsDetails) {
//         const addonPayload = {
//           hospitalID: parseInt(hospitalID),
//           addon_name: addon.name,
//           start_date: formatDateForDB(new Date()),
//           valid_date: formatDateForDB(calculateAddonEndDate(new Date(), addonValidity)),
//           amount: String(addon.price * addonValidity),
//           transactionId: transactionId,
//           status: 'active',
//           payment_status: 'Paid'
//         };
//         await dispatch(createBusinessAddon(addonPayload));
//       }
//     }

//     // 3. User Table Update (Active Status)
//     const userPayload = prepareCleanUserPayload('active', planType);
//     await dispatch(updateUser(userPayload));
    
//     // LocalStorage update (Sidebar isi se status read karega)
//     localStorage.setItem('loginData', JSON.stringify(userPayload));
//     localStorage.setItem('subscriptionStatus', 'active'); // Extra check for sidebar

//     setPaymentStatus('success');
//     setPaymentStatusMessage('Account Activated! Redirecting to Dashboard...');
    
//     // IMPORTANT: Thoda wait karein taaki DB update ho jaye phir reload karein
//     setTimeout(() => {
//         lastSelectedPlanRef.current = { planType, isModification: false };
//         setLocalSuccess(true); // Yeh useEffect ko trigger karega niche wala
//     }, 2000);

//   } catch (error) {
//     console.error("Payment Success Entry Error:", error);
//     setPaymentStatus('error');
//     setPaymentStatusMessage('Error updating profile. Please refresh manually.');
//   }
// };
// const createBusinessModuleAfterPayment = async (paymentData) => {
//   try {
//     const { planType, planId, addons, addonsDetails, basePlanValidity, addonValidity, amount, transactionId, isModification } = paymentData;

//     setIsProcessingPayment(true);
//     setPaymentStatus('processing');
//     setPaymentStatusMessage('Payment Verified! Updating your records...');

//     // 1. Business Module Entry
//     if (!isModification) {
//       await dispatch(createBusinessModule(createBasePlanPayload(planType, planId, addons, basePlanValidity, amount, transactionId, "Paid")));
//     }

//     // 2. Addons Entry
//     if (addonsDetails && addonsDetails.length > 0) {
//       for (const addon of addonsDetails) {
//         await dispatch(createBusinessAddon({
//           hospitalID: parseInt(hospitalID),
//           addon_name: addon.name,
//           start_date: formatDateForDB(new Date()),
//           valid_date: formatDateForDB(calculateAddonEndDate(new Date(), addonValidity)),
//           amount: String(addon.price * addonValidity),
//           transactionId: transactionId,
//           status: 'active',
//           payment_status: 'Paid'
//         }));
//       }
//     }

//     // 3. User Table Sync (Isse separate try-catch me rakhein)
//     try {
//       const userPayload = prepareCleanUserPayload('active', planType);
//       await dispatch(updateUser(userPayload));
//       localStorage.setItem('loginData', JSON.stringify(userPayload));
//     } catch (userErr) {
//       console.error("User Table Update Failed (404), but DB entries were made", userErr);
//       // Yahan error na dikhayein kyunki payment success ho chuka hai
//     }

//     setPaymentStatus('success');
//     setPaymentStatusMessage('Plan Activated Successfully!');

//     setTimeout(() => {
//       lastSelectedPlanRef.current = { planType, isModification };
//       setLocalSuccess(true); 
//     }, 2000);

//   } catch (error) {
//     console.error("Critical Sync Error:", error);
//     setPaymentStatus('error');
//     setPaymentStatusMessage('Payment done but DB sync failed. Please contact support.');
//   }
// };
// ==================== SMS HELPER FUNCTIONS ====================

// SMS 1: Subscription Renewed (Plan purchase/renewal ke baad)
const sendSubscriptionRenewalSms = async (planType, validToDate) => {
    try {
        const loginData = JSON.parse(localStorage.getItem('loginData') || '{}');
        const doctorName = `${loginData.first_name || ''} ${loginData.last_name || ''}`.trim();
        const mobile = loginData.mobile;

        if (!mobile) {
            console.log('[SMS] No mobile found, skipping subscription SMS');
            return;
        }

        // valid_To date format DD-MM-YYYY hai, display ke liye convert karo
        let expiryDisplay = 'N/A';
        if (validToDate) {
            const parts = validToDate.split('-');
            if (parts.length === 3) {
                expiryDisplay = `${parts[0]}-${parts[1]}-${parts[2]}`;
            }
        } else {
            expiryDisplay = 'No Expiry (Commission Plan)';
        }

        console.log('[SMS] Sending subscription renewal SMS', { doctorName, mobile, expiryDisplay });

        await dispatch(sendConfirmationSms({
            hid: "2",
            recipientPhone: mobile,
            eventId: "MEDISEVAS_APP_DOCTOR_PRODUCT_RENEWAL",
            templateData: {
                doctorName: doctorName,
                newExpiryDate: expiryDisplay,
            },
        }));

        console.log('[SMS] Subscription renewal SMS sent successfully');
    } catch (error) {
        console.error('[SMS] Failed to send subscription renewal SMS:', error);
        // SMS fail hone par plan activation rok mat — silently fail karo
    }
};

// SMS 2: Addon Activated (Addon purchase ke baad)
const sendAddonActivatedSms = async (addonName, amount, startDate, endDate) => {
    try {
        const loginData = JSON.parse(localStorage.getItem('loginData') || '{}');
        const doctorName = `${loginData.first_name || ''} ${loginData.last_name || ''}`.trim();
        const mobile = loginData.mobile;

        if (!mobile) {
            console.log('[SMS] No mobile found, skipping addon SMS');
            return;
        }

        console.log('[SMS] Sending addon activated SMS', { doctorName, mobile, addonName });

        await dispatch(sendConfirmationSms({
            hid: "2",
            recipientPhone: mobile,
            eventId: "MEDISEVAS_APP_ADDON_ACTIVATED",
            templateData: {
                doctorName: doctorName,
                addonPackage: addonName,
                amount: String(amount),
                startDate: startDate,
                endDate: endDate,
            },
        }));

        console.log('[SMS] Addon activated SMS sent successfully');
    } catch (error) {
        console.error('[SMS] Failed to send addon activated SMS:', error);
        // SMS fail hone par plan activation rok mat — silently fail karo
    }
};
const createBusinessModuleAfterPayment = async (paymentData) => {
    try {
        const {
            planType,
            planId,
            addons,
            addonsDetails,
            basePlanValidity,
            addonValidity,
            amount,
            transactionId,
            isModification
        } = paymentData;

        setIsProcessingPayment(true);
        setPaymentStatus('processing');
        setPaymentStatusMessage('Payment Verified! Updating your records...');

        // 1. Business Module Entry (existing — mat badlo)
        if (!isModification) {
            await dispatch(createBusinessModule(
                createBasePlanPayload(planType, planId, addons, basePlanValidity, amount, transactionId, "Paid")
            ));
        }

        // 2. Addons Entry (existing — mat badlo)
        if (addonsDetails && addonsDetails.length > 0) {
            for (const addon of addonsDetails) {
                await dispatch(createBusinessAddon({
                    hospitalID: parseInt(hospitalID),
                    addon_name: addon.name,
                    start_date: formatDateForDB(new Date()),
                    valid_date: formatDateForDB(calculateAddonEndDate(new Date(), addonValidity)),
                    amount: String(addon.price * addonValidity),
                    transactionId: transactionId,
                    status: 'active',
                    payment_status: 'Paid'
                }));
            }
        }

        // 3. User Table Sync (existing — mat badlo)
        try {
            const userPayload = prepareCleanUserPayload('active', planType);
            await dispatch(updateUser(userPayload));
        } catch (userErr) {
            console.error("User Table Update Failed:", userErr);
        }

        // 4. Redux update (existing — mat badlo)
        dispatch(updateSubscriptionStatus('active', planType));
        console.log('[PlanSelection] Subscription status updated in Redux and localStorage');

        // ✅ SIRF YE BLOCK ADD KARO — baaki sab same hai
        // SMS 1: Subscription renewal SMS (sirf base plan ke liye, modification nahi)
        if (!isModification) {
            const basePayload = createBasePlanPayload(planType, planId, addons, basePlanValidity, amount, transactionId, "Paid");
            const validTo = planType === 'commission' ? null : basePayload.valid_To;
            await sendSubscriptionRenewalSms(planType, validTo);
        }

        // SMS 2: Addon activation SMS (har purchased addon ke liye)
        if (addonsDetails && addonsDetails.length > 0) {
            const startDateFormatted = formatDateForDB(new Date());
            const endDateFormatted = formatDateForDB(calculateAddonEndDate(new Date(), addonValidity));

            for (const addon of addonsDetails) {
                const addonTotalAmount = addon.price * addonValidity;
                await sendAddonActivatedSms(
                    addon.name,
                    addonTotalAmount,
                    startDateFormatted,
                    endDateFormatted
                );
            }
        }
        // ✅ END

        setPaymentStatus('success');
        setPaymentStatusMessage('Plan Activated Successfully!');

        setTimeout(() => {
            lastSelectedPlanRef.current = { planType, isModification };
            setLocalSuccess(true);
        }, 2000);

    } catch (error) {
        console.error("Critical Sync Error:", error);
        setPaymentStatus('error');
        setPaymentStatusMessage('Payment done but sync failed. Please refresh.');
    }
};
// const createBusinessModuleAfterPayment = async (paymentData) => {
//     try {
//         const {
//             planType,
//             planId,
//             addons,
//             addonsDetails,
//             basePlanValidity,
//             addonValidity,
//             amount,
//             transactionId,
//             isModification
//         } = paymentData;
 
//         setIsProcessingPayment(true);
//         setPaymentStatus('processing');
//         setPaymentStatusMessage('Payment Verified! Updating your records...');
 
//         // 1. Business Module Entry (existing code — mat badlo)
//         if (!isModification) {
//             await dispatch(createBusinessModule(
//                 createBasePlanPayload(planType, planId, addons, basePlanValidity, amount, transactionId, "Paid")
//             ));
//         }
 
//         // 2. Addons Entry (existing code — mat badlo)
//         if (addonsDetails && addonsDetails.length > 0) {
//             for (const addon of addonsDetails) {
//                 await dispatch(createBusinessAddon({
//                     hospitalID: parseInt(hospitalID),
//                     addon_name: addon.name,
//                     start_date: formatDateForDB(new Date()),
//                     valid_date: formatDateForDB(calculateAddonEndDate(new Date(), addonValidity)),
//                     amount: String(addon.price * addonValidity),
//                     transactionId: transactionId,
//                     status: 'active',
//                     payment_status: 'Paid'
//                 }));
//             }
//         }
 
//         // 3. User Table Sync (existing code — mat badlo)
//         try {
//             const userPayload = prepareCleanUserPayload('active', planType);
//             await dispatch(updateUser(userPayload));
//             // localStorage bhi update hoga updateUser ke andar
//         } catch (userErr) {
//             console.error("User Table Update Failed:", userErr);
//         }
 
//         // ✅ CHANGE 2A: YE NAI LINES ADD KARO — IMAGE KA STEP 10
//         // Plan purchase success hone ke baad Redux subscriptionStatus update karo
//         // Isse sidebar automatically unlock ho jayegi bina page reload ke
//         dispatch(updateSubscriptionStatus('active', planType));
//         // localStorage update bhi hoga updateSubscriptionStatus ke andar
//         console.log('[PlanSelection] Subscription status updated in Redux and localStorage');
 
//         setPaymentStatus('success');
//         setPaymentStatusMessage('Plan Activated Successfully!');
 
//         // ✅ CHANGE 2B: setTimeout mein sirf dashboard navigate karo
//         // window.location.reload() mat karo — Redux already update ho gaya hai
//         setTimeout(() => {
//             lastSelectedPlanRef.current = { planType, isModification };
//             setLocalSuccess(true);
//         }, 2000);
 
//     } catch (error) {
//         console.error("Critical Sync Error:", error);
//         setPaymentStatus('error');
//         setPaymentStatusMessage('Payment done but sync failed. Please refresh.');
//     }
// };
// Success hone par reload karne wala useEffect
// useEffect(() => {
//   if (localSuccess) {
//     // Sab kuch saaf karein aur Dashboard pe bhej kar hard reload karein
//     localStorage.removeItem('pending_cashfree_order');
//     dispatch(clearBusinessModuleSuccess());
    
//     // Hard Reload taaki Sidebar ki API fresh call ho
//     window.location.href = "/#/doctor/dashboard";
//     window.location.reload(true); 
//   }
// }, [localSuccess, dispatch]);
  // ==================== PAYLOAD CREATION ====================

  // Create base plan payload for business_module table
  const createBasePlanPayload = (planType = selectedPlan, planId = selectedPlanId, addons = selectedAddons,
    validity = basePlanValidity, amount = 0, transactionId = '', status = 'Paid') => {

    const today = new Date();
    const formattedDate = date => {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    };

    const selectedPlanData = getSelectedPlanDetails();
    const isModification = isModifyingCurrentPlan();

    let payload = {
      hospitalID: parseInt(hospitalID),
      businessType: planType,
      valid_From: formattedDate(today),
      valid_To: '',
      addonModules: null,
      transactionId: transactionId || `TXN_${Date.now()}_${Math.floor(Math.random() * 1000)}`,
      amount: String(amount),
      status: status,
      payment_status: "paid" // Added payment_status field
    };

    if (isModification && currentPlan?.valid_To) {
      payload.valid_To = currentPlan.valid_To;
      log('📅 Using existing plan validity for modification', payload.valid_To);
    } else {
      const validToDate = new Date();
      if (planType === 'commission') {
        payload.valid_To = '';
        log('📅 Commission plan - no expiry date');
      } else {
        validToDate.setMonth(validToDate.getMonth() + validity);
        payload.valid_To = formattedDate(validToDate);
        log('📅 New subscription plan validity set', { validity, validTo: payload.valid_To });
      }
    }

    log('✅ Final base plan payload created', payload);
    return payload;
  };

  // ==================== UI COMPONENTS ====================

  // ValiditySelector Component
  const ValiditySelector = ({
    value,
    onChange,
    options,
    label,
    disabled = false,
    showDiscount = true
  }) => {
    log('🎯 Rendering ValiditySelector', { value, label, options: options.length, disabled });

    return (
      <div className="mb-3">
        <label className="form-label small text-muted mb-1">{label}</label>
        <select
          className="form-select form-select-sm"
          value={value}
          onChange={(e) => onChange(parseInt(e.target.value))}
          disabled={disabled}
        >
          {options.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        {showDiscount && options.find(opt => opt.value === value)?.discount > 0 && (
          <small className="text-success mt-1 d-block">
            {options.find(opt => opt.value === value)?.discount}% discount applied
          </small>
        )}
      </div>
    );
  };

  const AddonSelector = ({ addon, isSelected, onToggle, isExisting = false, onRemove }) => {
    log('🎯 Rendering AddonSelector', { addon: addon.id, isSelected, isExisting });

    const isVideoAddon = addon.name?.toLowerCase().includes('video');

    const getCardStyle = () => {
      if (isExisting) {
        return {
          border: '2px solid #28a745',
          backgroundColor: '#f8fff9',
          cursor: 'default',
          height: '100%',
          minHeight: isVideoAddon && isSelected ? '180px' : '160px',
          position: 'relative'
        };
      }
      if (isSelected) {
        return {
          border: '2px solid #007bff',
          backgroundColor: '#f0f8ff',
          cursor: 'pointer',
          height: '100%',
          minHeight: isVideoAddon ? '180px' : '160px'
        };
      }
      return {
        border: '1px solid #dee2e6',
        backgroundColor: '#ffffff',
        cursor: 'pointer',
        height: '100%',
        minHeight: '160px'
      };
    };

    const handleClick = () => {
      if (isExisting) {
        log('🚫 Addon is existing, cannot toggle', addon.id);
        return;
      }

      log('🔄 Toggling addon', { addon: addon.id, currentlySelected: isSelected });
      onToggle(addon.id);
    };

    const addonInfo = getActiveBusinessAddons().find(a => {
      const addonPackagesMap = getAddonPackages();
      const addonName = addonPackagesMap[addon.id]?.name;
      return a.addon_name === addonName;
    });

    return (
      <div
        className="card shadow-sm position-relative"
        style={getCardStyle()}
        onClick={handleClick}
      >
        <div className="card-body p-3 d-flex flex-column h-100">
          {!isExisting && (
            <div className="position-absolute top-0 end-0 p-2">
              <input
                className="form-check-input"
                type="checkbox"
                checked={isSelected}
                onChange={() => { }}
                onClick={(e) => {
                  e.stopPropagation();
                  onToggle(addon.id);
                }}
                style={{
                  transform: 'scale(1.1)',
                  cursor: 'pointer',
                  backgroundColor: isSelected ? '#007bff' : '',
                  borderColor: isSelected ? '#007bff' : ''
                }}
              />
            </div>
          )}

          {isExisting && onRemove && (
            <div className="position-absolute top-0 end-0 p-1">
              <button
                className="btn btn-outline-danger btn-sm remove-btn"
                style={{
                  width: '28px',
                  height: '28px',
                  padding: '0',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '50%',
                  border: '2px solid #dc3545'
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  onRemove(addon.id);
                }}
                title={`Remove ${addon.name}`}
              >
                <i className="fas fa-times" style={{ fontSize: '0.8rem' }}></i>
              </button>
            </div>
          )}

          <div className="d-flex justify-content-between align-items-start mb-2">
            <h6
              className="card-title mb-0"
              style={{
                fontSize: '0.85rem',
                lineHeight: '1.2',
                paddingRight: isExisting ? '45px' : '30px',
                color: isExisting ? '#155724' : 'inherit'
              }}
            >
              {addon.name}
              {isExisting && (
                <span className="badge bg-success ms-1" style={{ fontSize: '0.6rem' }}>
                  Active
                </span>
              )}
            </h6>
          </div>

          <p
            className="card-text flex-grow-1 mb-0"
            style={{
              fontSize: '0.75rem',
              lineHeight: '1.3',
              display: '-webkit-box',
              WebkitLineClamp: 3,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              color: isExisting ? '#155724' : '#6c757d'
            }}
          >
            {addon.description}
          </p>

          {isVideoAddon && isSelected && !isExisting && (
            <div className="alert alert-info py-1 px-2 mb-2" style={{ fontSize: '0.7rem' }}>
              <i className="fas fa-info-circle me-1"></i>
              Please set Video consulting price from profile settings to show you are available for video consulting.
            </div>
          )}

          <div className="mt-auto">
            <div className="d-flex align-items-center justify-content-between">
              <small
                className="fw-bold"
                style={{
                  fontSize: '0.75rem',
                  color: isExisting ? '#155724' : '#007bff'
                }}
              >
                ₹{addon.price}/month
              </small>
            </div>

            {isExisting && addonInfo && (
              <div className="mt-1">
                <small className="text-success d-block" style={{ fontSize: '0.65rem' }}>
                  <i className="fas fa-calendar-check me-1"></i>
                  Valid till: {formatDisplayDate(addonInfo.valid_date)}
                </small>
              </div>
            )}

            {!isExisting && isSelected && (
              <small className="text-info d-block mt-1" style={{ fontSize: '0.65rem' }}>
                <i className="fas fa-plus-circle me-1"></i>
                Selected for addition
                {isVideoAddon && (
                  <span className="text-warning ms-1">
                    <i className="fas fa-exclamation-circle me-1"></i>
                    Set profile price
                  </span>
                )}
              </small>
            )}
          </div>
        </div>
      </div>
    );
  };

  // SelectedOptionsTable Component
  const SelectedOptionsTable = () => {
    const selection = getSelectedFeatures();

    if (!selection) {
      log('❌ No selection data for SelectedOptionsTable');
      return (
        <div className="card  shadow" style={{ maxWidth: '400px' }}>
          <div className="card-headers filter-bar text-white p-2">
            <h6 className="card-title mb-0 text-center">
              Plan Selection
            </h6>
          </div>
          <div className="card-body p-3 text-center">
            <p className="text-muted small mb-3">
              Select modules to see payment details
            </p>
          </div>
        </div>
      );
    }

    const isModification = selection.isModification || modificationMode;
    const isPlanSwitch = selection.isPlanSwitch;
    const hasPayment = selection.total > 0;
    const requiresPayment = selection.total > 0;
    const hasNewAddons = selection.newAddons && selection.newAddons.length > 0;
    const hasAnyAddons = selection.addons && selection.addons.length > 0;

    const validAddons = (selection.addons || []).filter(addon => addon && addon.id);

    log('🎯 Rendering SelectedOptionsTable', {
      selection,
      isModification,
      isPlanSwitch,
      hasPayment,
      requiresPayment,
      hasNewAddons,
      hasAnyAddons,
      validAddons: validAddons.length,
      selectedAddons
    });

    let buttonText = '';
    let buttonVariant = 'btn-outline-secondary';
    let isButtonDisabled = false;
    let showButton = true;

    if (isActivating) {
      buttonText = 'Processing...';
      buttonVariant = 'btn-info';
      isButtonDisabled = true;
    } else if (requiresPayment) {
      buttonText = `Pay ₹${selection.total.toFixed(2)}`;
      buttonVariant = 'btn-info';
      isButtonDisabled = false;
    } else if (isPlanSwitch) {
      buttonText = `Switch to ${selection.type === 'subscription' ? 'Subscription' : 'Commission'}`;
      buttonVariant = 'btn-info';
      isButtonDisabled = false;
    } else if (hasNewAddons) {
      buttonText = 'Update Plan';
      buttonVariant = 'btn-info';
      isButtonDisabled = false;
    } else if (isModification) {
      buttonText = 'No Changes';
      buttonVariant = 'btn-outline-info';
      isButtonDisabled = true;
    } else {
      buttonText = 'Activate Plan';
      buttonVariant = 'btn-info';
      isButtonDisabled = false;
    }

    return (
      <div className="card  shadow" style={{ maxWidth: '400px' }}>
        <div className="card-headers filter-bar text-white p-2">
          <h6 className="card-title mb-0 text-center">
            {isModification ? 'Plan Modification' :
              isPlanSwitch ? 'Plan Switch' : 'Your Selected Plan'}
          </h6>
        </div>
        <div className="card-body p-3">
          <div className="d-flex justify-content-between align-items-start mb-2">
            <h6 className="card-subtitle text-dark">{selection.name}</h6>
            {selection.type === 'subscription' ? (
              <div className="text-end">
                {!isModification && !isPlanSwitch ? (
                  <>
                    <div className="text-info fw-bold">₹{selection.price}/month</div>
                    <small className="text-muted">Base plan</small>
                  </>
                ) : (
                  <div className="text-success fw-bold">
                    <i className="fas fa-check-circle me-1"></i>
                    {isPlanSwitch ? 'New Plan' : 'Base Plan Active'}
                  </div>
                )}
              </div>
            ) : (
              <div className="text-end">
                <div className="text-success fw-bold">
                  <i className="fas fa-check-circle me-1"></i>
                  {isPlanSwitch ? 'New Plan' : 'Free Base Plan'}
                </div>
                <small className="text-muted">{selection.rate}% commission</small>
              </div>
            )}
          </div>

          {isPlanSwitch && (
            <div className="alert alert-info py-2 mb-2">
              <small>
                <i className="fas fa-info-circle me-1"></i>
                Switching from {currentPlan?.businessType} to {selection.type} plan
                {hasAnyAddons && (
                  <span> with {validAddons.length} existing module(s)</span>
                )}
              </small>
            </div>
          )}

          {!isPlanSwitch && selection.type === 'subscription' && (
            <div className="mb-2">
              <div className="d-flex justify-content-between align-items-center">
                <small className="text-muted">Base Plan Validity:</small>
                <small className="text-info fw-bold">
                  {selection.basePlanValidity} month{selection.basePlanValidity > 1 ? 's' : ''}
                  {selection.currentBaseValidityOption?.discount > 0 && (
                    <span className="text-success ms-1">
                      ({selection.currentBaseValidityOption.discount}% off)
                    </span>
                  )}
                </small>
              </div>
            </div>
          )}

          {!isPlanSwitch && (
            <div className="mb-2">
              <div className="d-flex justify-content-between align-items-center">
                <small className="text-muted">Addon Validity:</small>
                <small className="text-info fw-bold">
                  {selection.addonValidity} month{selection.addonValidity > 1 ? 's' : ''}
                  {selection.currentAddonValidityOption?.discount > 0 && (
                    <span className="text-success ms-1">
                      ({selection.currentAddonValidityOption.discount}% off)
                    </span>
                  )}
                </small>
              </div>
            </div>
          )}

          {validAddons.length > 0 && (
            <div className="mb-2">
              <h6 className="text-muted mb-1">
                {isPlanSwitch ? 'Existing Modules:' :
                  isModification ? 'All Modules:' : 'Selected Modules:'}
                <span className="badge bg-info ms-1">{validAddons.length}</span>
              </h6>
              <div style={{ maxHeight: '150px', overflowY: 'auto' }}>
                {validAddons.map((addon, index) => {
                  const isNew = selection.newAddons && selection.newAddons.includes(addon.id);
                  const isExisting = selection.existingAddons && selection.existingAddons.includes(addon.id);

                  return (
                    <div
                      key={addon.id || index}
                      className={`d-flex justify-content-between align-items-center p-1 mb-1 rounded ${isNew ? 'bg-success text-white' :
                          isExisting ? 'bg-info text-white' : 'bg-light'
                        }`}
                      style={{ fontSize: '0.75rem' }}
                    >
                      <span>
                        {addon.name}
                        {isNew && <i className="fas fa-plus-circle ms-1"></i>}
                        {isExisting && <i className="fas fa-check-circle ms-1"></i>}
                      </span>
                      <span>₹{addon.price}/month</span>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {(hasPayment || isPlanSwitch) && (
            <div className="border-top pt-2">
              {hasPayment ? (
                <>
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <small><strong>Total Payment:</strong></small>
                    <span className="text-info fw-bold h6 mb-0">
                      ₹{selection.total.toFixed(2)}
                    </span>
                  </div>

                  {selection.type === 'subscription' && !isModification && !isPlanSwitch && (
                    <div className="d-flex justify-content-between">
                      <small className="text-muted">Base plan:</small>
                      <small className="text-muted">₹{selection.baseTotal?.toFixed(2)}</small>
                    </div>
                  )}

                  {selection.addonTotal > 0 && (
                    <div className="d-flex justify-content-between">
                      <small className="text-muted">
                        {selection.newAddonsCount > 0 ? 'New modules:' : 'Modules:'}
                      </small>
                      <small className="text-muted">₹{selection.addonTotal.toFixed(2)}</small>
                    </div>
                  )}
                </>
              ) : isPlanSwitch ? (
                <div className="text-center py-1">
                  <small className="text-success">
                    <i className="fas fa-check-circle me-1"></i>
                    {selection.type === 'commission'
                      ? 'No payment required for commission plan switch'
                      : 'Payment required for subscription base plan'
                    }
                  </small>
                </div>
              ) : null}
            </div>
          )}

          {showButton && (
            <button
              className={`btn w-100 mt-2 ${buttonVariant}`}
              onClick={handleFinalizeSelection}
              disabled={isButtonDisabled}
            >
              {isActivating ? (
                <>
                  <span className="spinner-border spinner-border-sm me-1"></span>
                  Processing...
                </>
              ) : (
                <>
                  {requiresPayment && <i className="fas fa-credit-card me-1"></i>}
                  {!requiresPayment && (isPlanSwitch || hasNewAddons) && <i className="fas fa-check-circle me-1"></i>}
                  {buttonText}
                </>
              )}
            </button>
          )}

          {!requiresPayment && selection.type === 'commission' && !isPlanSwitch && (
            <small className="text-muted text-center d-block mt-1">
              Free base plan with {selection.rate}% commission
            </small>
          )}

          {isPlanSwitch && (
            <small className="text-muted text-center d-block mt-1">
              Your existing modules will remain active
            </small>
          )}

          {!hasNewAddons && isModification && !isPlanSwitch && (
            <small className="text-muted text-center d-block mt-1">
              No new modules selected
            </small>
          )}
        </div>
      </div>
    );
  };

  // CurrentPlanDisplay Component
  const CurrentPlanDisplay = () => {
    log('🎯 Rendering CurrentPlanDisplay', { currentPlan });

    if (!currentPlan) {
      log('📝 No current plan to display');
      return (
        <div className="card mb-4">
          <div className="card-header bg-warning text-dark">
            <h6 className="card-title mb-0">No Active Plan</h6>
          </div>
          <div className="card-body text-center py-4">
            <p className="text-muted small mb-3">Please select a plan to get started.</p>
          </div>
        </div>
      );
    }

    const activeBusinessAddons = getActiveBusinessAddons();
    log('📦 Current plan active addons', { activeBusinessAddons });

    return (
      
      <div className="card  mb-4">
        <div className="card-headers filter-bar">
          <h6 className="card-title mb-0">
            <i className="fas fa-rocket me-2"></i>
            Current Active Plan & Paid Modules
          </h6>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <p><strong>Plan Type:</strong>
                <span className={`badge ms-2 ${currentPlan.businessType === 'subscription' ? 'bg-info' : 'bg-success'
                  }`}>
                  {currentPlan.businessType === 'subscription' ? 'Subscription' : 'Commission'}
                </span>
              </p>
              <p><strong>Plan Name:</strong> {currentPlan.planName || getPlanNameFromData(currentPlan) || 'N/A'}</p>
              <p><strong>Plan Started:</strong> {formatDisplayDate(currentPlan.valid_From) || 'N/A'}</p>
              <p><strong>Plan Valid Till:</strong> {formatDisplayDate(currentPlan.valid_To) || 'No expiry'}</p>
            </div>
            <div className="col-md-6">
              <p><strong>Status:</strong> <span className="badge bg-success">Active</span></p>
              <p><strong>Active Paid Modules:</strong> <span className="badge bg-info">{activeBusinessAddons.length}</span></p>
            </div>
          </div>

          {activeBusinessAddons.length > 0 && (
            <div className="mt-4">
              <h6 className="text-muted mb-3">
                <i className="fas fa-cubes me-2"></i>
                Active Paid Modules:
              </h6>
              <div className="table-responsive">
                <table className="table table-sm table-striped">
                  <thead>
                    <tr>
                      <th>Module Name</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                      <th>Amount Paid</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {activeBusinessAddons.map((addon, idx) => (
                      <tr key={idx}>
                        <td>{addon.addon_name}</td>
                        <td>{formatDisplayDate(addon.start_date)}</td>
                        <td>{formatDisplayDate(addon.valid_date)}</td>
                        <td>₹{addon.amount}</td>
                        <td><span className="badge bg-success">{addon.status}</span></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  // ==================== MAIN RENDER ====================

  const isLoading = loadingBusinessModels || loadingAddonPackages || loadingDiscounts || loadingAddons;

  log('🎯 Main render', {
    isLoading,
    selectedPlan,
    currentPlan,
    selectedAddons: selectedAddons.length,
    isModifyingExisting,
    modificationMode
  });

  if (isLoading) {
    return (
      <div className="container py-3">
        <div className="text-center py-4">
          <div className="spinner-border text-info" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-2 text-muted">Loading plans and modules...</p>
        </div>
      </div>
    );
  }

  // Modification mode view
  if (modificationMode) {
    const isModification = isModifyingCurrentPlan();
    const filteredAddonValidityOptions = getFilteredAddonValidityOptions();

    log('🎯 Rendering modification view', {
      selectedPlan,
      isModification,
      filteredAddonValidityOptions: filteredAddonValidityOptions.length,
      basePlanValidity,
      addonValidity,
      selectedAddons
    });

    return (
      <div className="container py-3">
        
        {/* Modification Header Card */}
        <div className="card  mb-4">
          <div className="card-headers filter-bar d-flex justify-content-between align-items-center">
            <h6 className="card-title mb-0">
              <i className="fas fa-edit me-2"></i>
              Modify Your Plan
            </h6>
            <button
              className="btn btn-danger btn-sm"
              onClick={handleCancelModification}
            >
              <i className="fas fa-times me-1"></i>
            </button>
          </div>
          
          <div className="card-body">
            <p className="text-muted mb-3">
              <i className="fas fa-info-circle me-2"></i>
              You can add new paid modules to your existing plan. Your current active modules will remain active until their expiry.
            </p>

            <div className="row">
              <div className="col-md-6">
                <div className="card bg-light">
                  <div className="card-body">
                    <h6 className="card-title">Current Plan Details</h6>
                    <p><strong>Plan:</strong> {currentPlan.planName || getPlanNameFromData(currentPlan)}</p>
                    <p><strong>Type:</strong> {currentPlan.businessType === 'subscription' ? 'Subscription' : 'Commission'}</p>
                    <p><strong>Valid Till:</strong> {formatDisplayDate(currentPlan.valid_To) || 'No expiry'}</p>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="card">
                  <div className="card-body">
                    <h6 className="card-title mb-3">Select Validity for New Modules</h6>
                    <ValiditySelector
                      value={addonValidity}
                      onChange={handleAddonValidityChange}
                      options={filteredAddonValidityOptions}
                      label="Module Validity Period"
                      disabled={isActivating}
                      showDiscount={true}
                    />
                    <small className="text-muted">
                      Choose how long you want to activate the new modules for.
                      {selectedPlan === 'subscription' && (
                        <span> Based on your plan validity till {formatDisplayDate(currentPlan.valid_To)}</span>
                      )}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-8">
            <div className="card mb-4">
              <div className="card-body p-3">
                <h6 className="card-title mb-2">Available Paid Modules</h6>
                <p className="text-muted small mb-3">
                  Select additional features - existing active modules are shown in green and cannot be modified
                  <br />
                  <span className="text-info">
                    <i className="fas fa-info-circle me-1"></i>
                    New modules will be activated for <strong>{addonValidity} month{addonValidity > 1 ? 's' : ''}</strong>
                  </span>
                </p>

                <div className="row g-4">
                  {Object.values(getAddonPackages())
                    .filter(addon => addon && addon.id)
                    .map(addon => {
                      const isExisting = checkIfAddonActive(addon.id);
                      const isSelected = selectedAddons.includes(addon.id);

                      log('🔍 Addon in selection', {
                        addon: addon.id,
                        name: addon.name,
                        isExisting,
                        isSelected
                      });

                      return (
                        <div key={addon.id} className="col-sm-6 col-md-4 col-lg-3">
                          <AddonSelector
                            addon={addon}
                            isSelected={isSelected}
                            isExisting={isExisting}
                            onToggle={handleAddonToggle}
                            onRemove={isExisting ? handleRemoveAddon : null}
                          />
                        </div>
                      );
                    })}
                </div>

                {Object.values(getAddonPackages()).filter(addon => addon && addon.id).length === 0 && (
                  <div className="text-center py-4">
                    <i className="fas fa-cube fa-2x text-muted mb-3"></i>
                    <p className="text-muted mb-0">No additional paid modules available</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="col-lg-4">
            <div className="card shadow">
              <div className="card-headers  filter-bar p-2">
                <h6 className="card-title mb-0 text-center">Plan Modification</h6>
              </div>
              <div className="card-body p-3">
                <div className="d-flex justify-content-between align-items-start mb-2">
                  <h6 className="card-subtitle text-dark">
                    {currentPlan.planName || getPlanNameFromData(currentPlan)}
                  </h6>
                  <div className="text-end">
                    <div className="text-success fw-bold">
                      <i className="fas fa-check-circle me-1"></i>
                      Base Plan Active
                    </div>
                    <small className="text-muted">
                      {currentPlan.businessType === 'subscription' ? 'Subscription' : 'Commission'}
                    </small>
                  </div>
                </div>

                <div className="mb-2">
                  <div className="d-flex justify-content-between align-items-center">
                    <small className="text-muted">New Modules Validity:</small>
                    <small className="text-info fw-bold">
                      {addonValidity} month{addonValidity > 1 ? 's' : ''}
                      {getCurrentAddonValidityOption()?.discount > 0 && (
                        <span className="text-success ms-1">
                          ({getCurrentAddonValidityOption().discount}% off)
                        </span>
                      )}
                    </small>
                  </div>
                </div>

                {selectedAddons.length > 0 && (
                  <div className="mb-2">
                    <h6 className="text-muted mb-1">
                      Selected Modules:
                      <span className="badge bg-info ms-1">{selectedAddons.length}</span>
                    </h6>
                    <div style={{ maxHeight: '150px', overflowY: 'auto' }}>
                      {selectedAddons.map((addonId, index) => {
                        const addon = getAddonPackages()[addonId];
                        if (!addon) return null;

                        const isExisting = checkIfAddonActive(addonId);
                        const isNew = !isExisting;

                        return (
                          <div
                            key={addonId}
                            className={`d-flex justify-content-between align-items-center p-1 mb-1 rounded ${isNew ? 'bg-success text-white' : 'bg-info text-white'
                              }`}
                            style={{ fontSize: '0.75rem' }}
                          >
                            <span>
                              {addon.name}
                              {isNew && <i className="fas fa-plus-circle ms-1"></i>}
                              {isExisting && <i className="fas fa-check-circle ms-1"></i>}
                            </span>
                            <span>₹{addon.price}/month</span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}

                <div className="border-top pt-2">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <small><strong>Total Payment:</strong></small>
                    <span className="text-info fw-bold h6 mb-0">
                      ₹{calculateAddonTotal().total.toFixed(2)}
                    </span>
                  </div>

                  {calculateAddonTotal().newAddons.length > 0 && (
                    <div className="d-flex justify-content-between">
                      <small className="text-muted">New modules:</small>
                      <small className="text-muted">
                        {calculateAddonTotal().newAddons.length} module{calculateAddonTotal().newAddons.length > 1 ? 's' : ''}
                      </small>
                    </div>
                  )}

                  {calculateAddonTotal().addonSavings > 0 && (
                    <div className="d-flex justify-content-between">
                      <small className="text-muted">Discount savings:</small>
                      <small className="text-success">-₹{calculateAddonTotal().addonSavings.toFixed(2)}</small>
                    </div>
                  )}
                </div>

                <button
                  className={`btn w-100 mt-2 ${calculateAddonTotal().total > 0 ? 'btn-info' : 'btn-info'
                    }`}
                  onClick={handleFinalizeSelection}
                  disabled={isActivating || calculateAddonTotal().newAddons.length === 0}
                >
                  {isActivating ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-1"></span>
                      Processing...
                    </>
                  ) : calculateAddonTotal().total > 0 ? (
                    <>
                      <i className="fas fa-credit-card me-1"></i>
                      Pay ₹{calculateAddonTotal().total.toFixed(2)}
                    </>
                  ) : (
                    <>
                      <i className="fas fa-check-circle me-1"></i>
                      Update Plan
                    </>
                  )}
                </button>

                {calculateAddonTotal().newAddons.length === 0 && (
                  <small className="text-muted text-center d-block mt-1">
                    Select new modules to proceed with modification
                  </small>
                )}

                {calculateAddonTotal().total === 0 && calculateAddonTotal().newAddons.length > 0 && (
                  <small className="text-success text-center d-block mt-1">
                    <i className="fas fa-check-circle me-1"></i>
                    Free modification - no payment required
                  </small>
                )}
              </div>
            </div>
          </div>
        </div>

        <PaymentGatewayModal
          show={showPaymentModal}
          onClose={() => {
            log('🔄 Closing payment modal');
            setShowPaymentModal(false);
            setIsProcessingPayment(false);
          }}
          gateways={gateways}
          selectedGateway={selectedGateway}
          onSelectGateway={setSelectedGateway}
          onConfirm={handlePaymentConfirm}
          amount={pendingPaymentData?.amount || 0}
          loading={isProcessingPayment}
          planType={selectedPlan}
        />

        <PaymentStatus
          status={paymentStatus}
          message={paymentStatusMessage}
          onClose={() => {
            setPaymentStatus(null);
            setPaymentStatusMessage('');
            setIsProcessingPayment(false);
          }}
        />

        <MessageModal
          show={modalShow}
          onClose={() => {
            if (window.pendingAddonRemoval) {
              log('❌ Addon removal cancelled by user');
              window.pendingAddonRemoval = null;
            }
            setModalShow(false);
          }}
          onConfirm={() => {
            if (window.pendingAddonRemoval) {
              confirmAddonRemoval();
            } else {
              setModalShow(false);
            }
          }}
          title={modalTitle}
          message={modalMessage}
          variant={modalVariant}
          showConfirm={modalVariant === "warning" && modalTitle === "Confirm Removal"}
          confirmText="Yes, Remove"
          cancelText="Cancel"
        />
      </div>
    );
  }

  // Plan selection view
  if (selectedPlan && !modificationMode) {
    const isModification = isModifyingCurrentPlan();
    const filteredAddonValidityOptions = getFilteredAddonValidityOptions();

    log('🎯 Rendering plan customization view', {
      selectedPlan,
      isModification,
      filteredAddonValidityOptions: filteredAddonValidityOptions.length,
      basePlanValidity,
      addonValidity,
      selectedAddons
    });

    return (
      <div className="container py-3">
        <CurrentPlanDisplay />

        <div className="text-center mb-3">
          <button
            className="btn btn-link text-decoration-none p-0 mb-1"
            onClick={() => {
              log('🔄 Going back to plan selection');
              setSelectedPlan(null);
              setSelectedPlanId(null);
              setSelectedAddons([]);
            }}
          >
            ← Back to Plans
          </button>
          <h5 className="mb-1">
            {isModification ? 'Modify Your Plan' : 'Customize Your Plan'}
          </h5>
          <p className="text-muted">
            {selectedPlan === 'subscription'
              ? 'Subscription base plan + paid modules'
              : 'Free commission base plan + paid modules'
            }
          </p>
        </div>

        {(localError || error) && (
          <div className="alert alert-danger text-center py-2" role="alert" style={{ fontSize: '0.85rem' }}>
            {localError || error}
          </div>
        )}

        <div className="row g-3">
          <div className="col-lg-8">
            {!isModification && (
              <div className="card mb-3">
                <div className="card-body">
                  <h6 className="card-title mb-3">Select Validity Period</h6>

                  <div className="row">
                    {selectedPlan === 'subscription' && (
                      <div className="col-md-6">
                        <ValiditySelector
                          value={basePlanValidity}
                          onChange={handleBasePlanValidityChange}
                          options={getValidityOptions()}
                          label="Base Plan Validity"
                          disabled={isActivating}
                          showDiscount={true}
                        />
                      </div>
                    )}
                    <div className={selectedPlan === 'subscription' ? 'col-md-6' : 'col-md-12'}>
                      <ValiditySelector
                        value={addonValidity}
                        onChange={handleAddonValidityChange}
                        options={filteredAddonValidityOptions}
                        label="Addon Validity"
                        disabled={isActivating}
                        showDiscount={true}
                      />
                      {selectedPlan === 'subscription' && (
                        <small className="text-muted">
                          Addon validity cannot exceed base plan validity for subscription plans
                        </small>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="card">
              <div className="card-body p-3">
                <h6 className="card-title mb-2">Available Paid Modules</h6>
                <p className="text-muted small mb-3">
                  Select additional features for your practice - all modules are paid
                  {!isModification && (
                    <span> • Selected validity: <strong>{addonValidity} month{addonValidity > 1 ? 's' : ''}</strong></span>
                  )}
                  {isModification && (
                    <span> • Only new modules will be charged</span>
                  )}
                </p>

                <div className="row g-4">
                  {Object.values(getAddonPackages())
                    .filter(addon => addon && addon.id)
                    .map(addon => {
                      const isExisting = checkIfAddonActive(addon.id);
                      const isSelected = selectedAddons.includes(addon.id);

                      log('🔍 Addon in selection', {
                        addon: addon.id,
                        name: addon.name,
                        isExisting,
                        isSelected
                      });

                      return (
                        <div key={addon.id} className="col-sm-6 col-md-4 col-lg-3">
                          <AddonSelector
                            addon={addon}
                            isSelected={isSelected}
                            isExisting={isExisting}
                            onToggle={handleAddonToggle}
                            onRemove={isExisting ? handleRemoveAddon : null}
                          />
                        </div>
                      );
                    })}
                </div>

                {Object.values(getAddonPackages()).filter(addon => addon && addon.id).length === 0 && (
                  <div className="text-center py-4">
                    <i className="fas fa-cube fa-2x text-muted mb-3"></i>
                    <p className="text-muted mb-0">No additional paid modules available</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="col-lg-4">
            <SelectedOptionsTable />
          </div>
        </div>

        <PaymentGatewayModal
          show={showPaymentModal}
          onClose={() => {
            log('🔄 Closing payment modal');
            setShowPaymentModal(false);
            setIsProcessingPayment(false);
          }}
          gateways={gateways}
          selectedGateway={selectedGateway}
          onSelectGateway={setSelectedGateway}
          onConfirm={handlePaymentConfirm}
          amount={pendingPaymentData?.amount || 0}
          loading={isProcessingPayment}
          planType={selectedPlan}
        />

        <PaymentStatus
          status={paymentStatus}
          message={paymentStatusMessage}
          onClose={() => {
            setPaymentStatus(null);
            setPaymentStatusMessage('');
            setIsProcessingPayment(false);
          }}
        />

        <MessageModal
          show={modalShow}
          onClose={() => {
            if (window.pendingAddonRemoval) {
              log('❌ Addon removal cancelled by user');
              window.pendingAddonRemoval = null;
            }
            setModalShow(false);
          }}
          onConfirm={() => {
            if (window.pendingAddonRemoval) {
              confirmAddonRemoval();
            } else {
              setModalShow(false);
            }
          }}
          title={modalTitle}
          message={modalMessage}
          variant={modalVariant}
          showConfirm={modalVariant === "warning" && modalTitle === "Confirm Removal"}
          confirmText="Yes, Remove"
          cancelText="Cancel"
        />
      </div>
    );
  }

  // Main plan selection view
  log('🎯 Rendering main plan selection view');
  return (
    
    <div className="">
       <div className="page-header filter-bar rounded ">
                <div className="row align-items-center">
                    <div className="col">
                        <h4 className="page-title">Plan Selection</h4>
                        <ul className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/doctor/dashboard">Doctor Dashboard</Link></li>
                            <li className="breadcrumb-item active">Plan Selection</li>
                        </ul>
                    </div>
                </div>
        </div>
<div className='card'>
<div className='card-body'>
      <CurrentPlanDisplay />

      <div className="text-center mb-5">
        <h4 className="text-dark mb-3">Choose Your Practice Plan</h4>
        <p className="text-muted lead">
          Select the plan that best fits your practice needs. All plans include optional paid modules for additional features.
        </p>
      </div>

      {(localError || error) && (
        <div className="alert alert-danger text-center py-2 mb-4" role="alert" style={{ fontSize: '0.85rem' }}>
          {localError || error}
        </div>
      )}

      {showConfirmUpgrade && (
        <div className="alert alert-warning text-center mb-4">
          <div className="d-flex flex-column align-items-center">
            <i className="fas fa-exchange-alt fa-2x text-warning mb-2"></i>
            <h6 className="mb-2">Plan Change Confirmation</h6>
            <p className="mb-3" style={{ fontSize: '0.9rem', lineHeight: '1.4' }}>
              {confirmMessage}
            </p>
            <div className="d-flex gap-2">
              <button className="btn btn-info rounded-pill btn-sm" onClick={() => {
                const selectedPlanData = getBusinessPlans().find(plan => plan.id === selectedPlanId);
                if (selectedPlanData) {
                  log('✅ Plan change confirmed', selectedPlanData);
                  proceedToPlanSelection(selectedPlanId, selectedPlanData.type);
                }
              }}>
                <i className="fas fa-check me-1"></i>Confirm Change
              </button>
              <button className="btn btn-secondary rounded-pill btn-sm" onClick={() => {
                log('❌ Plan change cancelled');
                setShowConfirmUpgrade(false);
                setSelectedPlanId(null);
                setConfirmMessage('');
              }}>
                <i className="fas fa-times me-1"></i>Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="row justify-content-center">
        {getBusinessPlans().map(plan => {
          const isCurrentPlanType = currentPlan && currentPlan.businessType === plan.type;

          return (
            <PlanCard
              key={plan.id}
              plan={plan}
              isCurrentPlanType={isCurrentPlanType}
              onSelect={() => handlePlanSelect(plan.id, plan.type)}
              onModify={() => handleModifyPlan()}
            />
          );
        })}

        {getBusinessPlans().length === 0 && (
          <div className="col-lg-6">
            <div className="card h-100 border-light shadow-sm">
              <div className="card-body text-center p-5">
                <i className="fas fa-cube fa-3x text-muted mb-3"></i>
                <h5 className="card-title text-muted">No Plans Available</h5>
                <p className="text-muted">Please contact administrator for available plans.</p>
                <button 
                  className="btn btn-info rounded-pill mt-2"
                  onClick={() => setRealTimeUpdates(prev => prev + 1)}
                >
                  <i className="fas fa-refresh me-2"></i>Reload Plans
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="row mt-5">
        <div className="col-12">
          <div className="card border-0 bg-light">
            <div className="card-body text-center py-4">
              <h6 className="text-info mb-3">
                <i className="fas fa-info-circle me-2"></i>
                Plan Information
              </h6>
              <div className="row">
                <div className="col-md-4 mb-3">
                  <i className="fas fa-sync-alt text-info fa-2x mb-2"></i>
                  <h6 className="text-dark">Easy Switching</h6>
                  <small className="text-muted">Switch between plans anytime. Your paid modules remain active.</small>
                </div>
                <div className="col-md-4 mb-3">
                  <i className="fas fa-cube text-info fa-2x mb-2"></i>
                  <h6 className="text-dark">Addon Modules</h6>
                  <small className="text-muted">Enhance your plan with optional paid modules for extra features.</small>
                </div>
                <div className="col-md-4 mb-3">
                  <i className="fas fa-shield-alt text-info fa-2x mb-2"></i>
                  <h6 className="text-dark">No Lock-in</h6>
                  <small className="text-muted">No long-term contracts. Change or cancel anytime.</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <PaymentGatewayModal
        show={showPaymentModal}
        onClose={() => setShowPaymentModal(false)}
        gateways={gateways}
        selectedGateway={selectedGateway}
        onSelectGateway={setSelectedGateway}
        onConfirm={handlePaymentConfirm}
        amount={pendingPaymentData?.amount || 0}
        loading={isProcessingPayment}
        planType={selectedPlan}
      />

      <PaymentStatus
        status={paymentStatus}
        message={paymentStatusMessage}
        onClose={() => {
          setPaymentStatus(null);
          setPaymentStatusMessage('');
          setIsProcessingPayment(false);
        }}
      />

      <MessageModal
        show={modalShow}
        onClose={() => {
          if (window.pendingAddonRemoval) {
            log('❌ Addon removal cancelled by user');
            window.pendingAddonRemoval = null;
          }
          setModalShow(false);
        }}
        onConfirm={() => {
          if (window.pendingAddonRemoval) {
            confirmAddonRemoval();
          } else {
            setModalShow(false);
          }
        }}
        title={modalTitle}
        message={modalMessage}
        variant={modalVariant}
        showConfirm={modalVariant === "warning" && modalTitle === "Confirm Removal"}
        confirmText="Yes, Remove"
        cancelText="Cancel"
      />
    </div>
  </div>
  </div>
   
  );
};

export default PlanSelection;